import React from 'react';
import '../template-file-css/document-file-template.css';


export const PBS_AdultAssessment = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='PBS_AdultAssessment' className='file-pdf-document'>
            <div className='file-template w-750'>
                <p>
                    <span className='eleHeader'>Presenting Problem/Chief Compliant</span>
                    <span className='small'>(Stressors/Source of Distress)</span>
                    <textarea id="txtPresentingProblem" name="txtPresentingProblem" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>History of Presenting Problems</span>
                    <textarea id="txtHxOfProblem" name="txtHxOfProblem" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Detailed Psychiatric History</span>
                    <span className='small'>(age of onset/progression of symptoms/remission/relapses/give full chronological history)</span>
                    <textarea id="txtDetailedPsychHistory" name="txtDetailedPsychHistory" className='add-only'></textarea>
                </p>
                <h2>Mental Health: Psychiatric Illnesses</h2>
                <p>
                    <span className='eleHeader'>History of Treatment for Mental Health/Psychiatric Illnesses</span>
                    <span className='small'>(give detailed history of services received, previous providers, agencies, hospital admissions, medication management, etc.)</span>
                    <input type="checkbox" id="cbHxOfTreatment" name="cbHxOfTreatment" className='add-only' value="1" /> None Reported <br />
                    <textarea id="txtHxOfTreatment" name="txtHxOfTreatment" className='add-only'></textarea>
                </p>
                <p>
                    <b>Previous Psychiatric Hospitalizations</b>

                </p>
                <table>
                    <tr>
                        <td className='w-200'><span className='eleHeader'>Hospital</span></td>
                        <td className='w-150'><span className='eleHeader'>Admission Date</span></td>
                        <td className='w-150'><span className='eleHeader'>Discharge Date</span></td>
                        <td className='w-250'><span className='eleHeader'>Reason (S/H ideations, stabilizations, etc.)</span></td>
                    </tr>
                    <tr>
                        <td className='w-200'><input type='text' id="txtHospital_1_1" name="txtHospital_1_1" className='add-only' /></td>
                        <td className='w-150'><input type='date' id="txtHospital_1_2" name="txtHospital_1_2" className='add-only' /></td>
                        <td className='w-150'><input type='date' id="txtHospital_1_3" name="txtHospital_1_3" className='add-only' /></td>
                        <td className='w-250'><input type='text' id="txtHospital_1_4" name="txtHospital_1_4" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-200'><input type='text' id="txtHospital_2_1" name="txtHospital_2_1" className='add-only' /></td>
                        <td className='w-150'><input type='date' id="txtHospital_2_2" name="txtHospital_2_2" className='add-only' /></td>
                        <td className='w-150'><input type='date' id="txtHospital_2_3" name="txtHospital_2_3" className='add-only' /></td>
                        <td className='w-250'><input type='text' id="txtHospital_2_4" name="txtHospital_2_4" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-200'><input type='text' id="txtHospital_3_1" name="txtHospital_3_1" className='add-only' /></td>
                        <td className='w-150'><input type='date' id="txtHospital_3_2" name="txtHospital_3_2" className='add-only' /></td>
                        <td className='w-150'><input type='date' id="txtHospital_3_3" name="txtHospital_3_3" className='add-only' /></td>
                        <td className='w-250'><input type='text' id="txtHospital_3_4" name="txtHospital_3_4" className='add-only' /></td>
                    </tr>
                </table>
                <p>
                    <b>Mental Health Treatment History</b>
                    <span className='small'>(Provide all treatment modalities as stated by consumer in a detailed, chronological order)</span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Agency</span></td>
                        <td className='w-150'><span className='eleHeader'>Date</span></td>
                        <td className='w-350'><span className='eleHeader'>Treatment Modalities/Services Received</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='text' id="txtHospital_4_1" name="txtHospital_4_1" className='add-only' /></td>
                        <td className='w-150'><input type='date' id="txtHospital_4_2" name="txtHospital_4_2" className='add-only' /></td>
                        <td className='w-350'><input type='text' id="txtHospital_4_3" name="txtHospital_4_3" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='text' id="txtHospital_5_1" name="txtHospital_5_1" className='add-only' /></td>
                        <td className='w-150'><input type='date' id="txtHospital_5_2" name="txtHospital_5_2" className='add-only' /></td>
                        <td className='w-350'><input type='text' id="txtHospital_5_3" name="txtHospital_5_3" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='text' id="txtHospital_6_1" name="txtHospital_6_1" className='add-only' /></td>
                        <td className='w-150'><input type='date' id="txtHospital_6_2" name="txtHospital_6_2" className='add-only' /></td>
                        <td className='w-350'><input type='text' id="txtHospital_6_3" name="txtHospital_6_3" className='add-only' /></td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Consumer's response to Mental Health Treatment/Medication </span>
                    <span className='small'>(most or least helpful/barriers)</span>
                    <textarea id="txtConsRespToMHTx" name="txtConsRespToMHTx" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Does client have Psychiatric Advance directives?</span>
                            <span className='small'>(If yes, attach Advance Directives to Assessment)</span>
                            <input type="radio" id="rbPsychAdvDir_Yes" name="rbPsychAdvDir" className='add-only' value="1" /> Yes &nbsp;
                            <input type="radio" id="rbPsychAdvDir_No" name="rbPsychAdvDir" className='add-only' value="2" /> No
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>If No, is assistance requested?</span>
                            <input type="radio" id="rbPsychAdvDirAssist_Yes" name="rbPsychAdvDirAssist" className='add-only' value="1" /> Yes &nbsp;
                            <input type="radio" id="rbPsychAdvDirAssisit_No" name="rbPsychAdvDirAssist" className='add-only' value="2" /> No
                        </td>
                    </tr>
                </table>
                <h2>Past Medical History</h2>
                <p>
                    <span className='eleHeader'>Past Medical Illness</span>
                    <span className='small'>(include all Non-Psychiatric illnesses)</span>
                    <textarea id="txtPastMedIllness" name="txtPastMedIllness" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Pertinent Health/Issues/Medical History</span>
                    <textarea id="txtPertinentHealthHistory" name="txtPertinentHealthHistory" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Compliance with Medical Treatment</span>
                    <span className='small'>(give details of consumer's compliance with doctor visits, medication intake, etc.)</span>
                    <textarea id="txtCompMedTreatment" name="txtCompMedTreatment" className='add-only'></textarea>
                </p>
                <h2>Current Medication Information</h2>
                <span className='small'>(include General/Medical/Psychiatric)</span>
                <table>
                    <tr>
                        <td className='w-150'><span className='eleHeader'>Medication </span></td>
                        <td className='w-200'><span className='eleHeader'>Rationale</span></td>
                        <td className='w-200'><span className='eleHeader'>Treatment Efficacy</span></td>
                        <td className='w-100'><span className='eleHeader'>Dosage/ Route/ Freq</span></td>
                        <td className='w-100'><span className='eleHeader'>Compliance</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id="txtMed_1_1" name="txtMed_1_1" className='add-only' /></td>
                        <td className='w-200'><input type='text' id="txtMed_1_2" name="txtMed_1_2" className='add-only' /></td>
                        <td className='w-200'><input type='text' id="txtMed_1_3" name="txtMed_1_3" className='add-only' /></td>
                        <td className='w-100'><input type='text' id="txtMed_1_4" name="txtMed_1_4" className='add-only' /></td>
                        <td className='w-100'>
                            <select id="ddlMed_1_5" name="ddlMed_1_5" className='add-only'>
                                <option value="NA"></option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                                <option value="Partial">Partial</option>
                                <option value="Unknown">Unknown</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id="txtMed_2_1" name="txtMed_2_1" className='add-only' /></td>
                        <td className='w-200'><input type='text' id="txtMed_2_2" name="txtMed_2_2" className='add-only' /></td>
                        <td className='w-200'><input type='text' id="txtMed_2_3" name="txtMed_2_3" className='add-only' /></td>
                        <td className='w-100'><input type='text' id="txtMed_2_4" name="txtMed_2_4" className='add-only' /></td>
                        <td className='w-100'>
                            <select id="ddlMed_2_5" name="ddlMed_2_5" className='add-only'>
                                <option value="NA"></option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                                <option value="Partial">Partial</option>
                                <option value="Unknown">Unknown</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id="txtMed_3_1" name="txtMed_3_1" className='add-only' /></td>
                        <td className='w-200'><input type='text' id="txtMed_3_2" name="txtMed_3_2" className='add-only' /></td>
                        <td className='w-200'><input type='text' id="txtMed_3_3" name="txtMed_3_3" className='add-only' /></td>
                        <td className='w-100'><input type='text' id="txtMed_3_4" name="txtMed_3_4" className='add-only' /></td>
                        <td className='w-100'>
                            <select id="ddlMed_3_5" name="ddlMed_3_5" className='add-only'>
                                <option value="NA"></option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                                <option value="Partial">Partial</option>
                                <option value="Unknown">Unknown</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id="txtMed_4_1" name="txtMed_4_1" className='add-only' /></td>
                        <td className='w-200'><input type='text' id="txtMed_4_2" name="txtMed_4_2" className='add-only' /></td>
                        <td className='w-200'><input type='text' id="txtMed_4_3" name="txtMed_4_3" className='add-only' /></td>
                        <td className='w-100'><input type='text' id="txtMed_4_4" name="txtMed_4_4" className='add-only' /></td>
                        <td className='w-100'>
                            <select id="ddlMed_4_5" name="ddlMed_4_5" className='add-only'>
                                <option value="NA"></option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                                <option value="Partial">Partial</option>
                                <option value="Unknown">Unknown</option>
                            </select>
                        </td>
                    </tr>
                </table>
                <h2>Past Psychotropic Medications</h2>
                <p><input type="checkbox" id="cbNoPastPsychMeds" name="cbNoPastPsychMeds" className='add-only' value="1" /> No  &nbsp;ne Reported</p>
                <table>
                    <tr>
                        <td className='w-200'><span className='eleHeader'>Psychotropic Medication</span></td>
                        <td className='w-550'><span className='eleHeader'>Efficacy of Previously Used Psychotropic Medication</span></td>
                    </tr>
                    <tr>
                        <td className='w-200'><input type='text' id="txtPastMed_1_1" name="txtPastMed_1_1" className='add-only' /></td>
                        <td className='w-550'><input type='text' id="txtPastMed_1_2" name="txtPastMed_1_2" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-200'><input type='text' id="txtPastMed_2_1" name="txtPastMed_2_1" className='add-only' /></td>
                        <td className='w-550'><input type='text' id="txtPastMed_2_2" name="txtPastMed_2_2" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-200'><input type='text' id="txtPastMed_3_1" name="txtPastMed_3_1" className='add-only' /></td>
                        <td className='w-550'><input type='text' id="txtPastMed_3_2" name="txtPastMed_3_2" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-200'><input type='text' id="txtPastMed_4_1" name="txtPastMed_4_1" className='add-only' /></td>
                        <td className='w-550'><input type='text' id="txtPastMed_4_2" name="txtPastMed_4_2" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-200'><input type='text' id="txtPastMed_5_1" name="txtPastMed_5_1" className='add-only' /></td>
                        <td className='w-550'><input type='text' id="txtPastMed_5_2" name="txtPastMed_5_2" className='add-only' /></td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Primary Care Physician</span>
                    <span className='small'>(name, phone no., and address)</span>
                    <textarea id="txtPrimaryCarePhys" name="txtPrimaryCarePhys" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Psychiatrist </span>
                    <span className='small'>(name, phone no., and address)</span>
                    <textarea id="txtPsychiatrist" name="txtPsychiatrist" className='add-only'></textarea>
                </p>
                <h2>Current Pregnancy/Prenatal Care</h2>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Currently Pregnant?</span>
                            <input type="checkbox" id="cbCurrPreg_Yes" name="cbCurrPreg" className='add-only' value="1" /> Yes &nbsp;
                            <input type="checkbox" id="cbCurrPreg_No" name="cbCurrPreg" className='add-only' value="2" /> No
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Receiving Prenatal Care?</span>
                            <input type="checkbox" id="cbPrenatal_Yes" name="cbPrenatal" className='add-only' value="1" /> Yes &nbsp;
                            <input type="checkbox" id="cbPrenatal_No" name="cbPrenatal" className='add-only' value="2" /> No
                        </td>
                    </tr>
                </table>
                <h2>Living Environment</h2>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>My Home</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type="checkbox" id="cbHome_1" name="cbHome" className='add-only' value="1" /> Rent</td>
                        <td className='w-187'><input type="checkbox" id="cbHome_2" name="cbHome" className='add-only' value="2" /> Own</td>
                        <td className='w-187'><input type="checkbox" id="cbHome_3" name="cbHome" className='add-only' value="3" /> Other</td>
                        <td className='w-187'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>**Other - My Home</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type="checkbox" id="cbHome_1_1" name="cbHome_1" className='add-only' value="1" /> Friend's House</td>
                        <td className='w-375'><input type="checkbox" id="cbHome_1_2" name="cbHome_1" className='add-only' value="2" /> Relative's/Guardian's Home</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type="checkbox" id="cbHome_1_3" name="cbHome_1" className='add-only' value="3" /> Foster Care Home</td>
                        <td className='w-375'><input type="checkbox" id="cbHome_1_4" name="cbHome_1" className='add-only' value="4" /> Homeless Lliving w/ Friend</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type="checkbox" id="cbHome_1_5" name="cbHome_1" className='add-only' value="5" /> Homeless in Shelter/No Residence</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbHome_1_6" name="cbHome_1" className='add-only' value="6" /> Other:
                            <input type='text' id="txtHome_1_7" name="txtHome_1_7" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>**Residential Care/Treatment Facility</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type="checkbox" id="cbResCare_1_1" name="cbResCare" className='add-only' value="1" /> Hospital</td>
                        <td className='w-187'><input type="checkbox" id="cbResCare_1_2" name="cbResCare" className='add-only' value="2" /> Temporary Housing</td>
                        <td className='w-187'><input type="checkbox" id="cbResCare_1_3" name="cbResCare" className='add-only' value="3" /> Residential Care</td>
                        <td className='w-187'><input type="checkbox" id="cbResCare_1_4" name="cbResCare" className='add-only' value="4" /> Nursing Home</td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>**Identify Facility or Person's Name</span></td>
                        <td className='w-375'><span className='eleHeader'>Are you safe where you live now?</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id="cbFacName_1" name="cbFacName" className='add-only' /></td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbSafe_1" name="cbSafe" className='add-only' value="1" /> Yes &nbsp;
                            <input type="checkbox" id="cbSafe_2" name="cbSafe" className='add-only' value="2" /> No</td>
                    </tr>
                </table>


                <table>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Significant Family Members</span></td>
                        <td className='w-125'><span className='eleHeader'>Relationship to Client</span></td>
                        <td className='w-75'><span className='eleHeader'>Age</span></td>
                        <td className='w-300'><span className='eleHeader'>Quality of Relationship</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='text' id="txtFamMems_1_1" name="txtFamMems_1_1" className='add-only' /></td>
                        <td className='w-125'><input type='text' id="txtFamMems_1_2" name="txtFamMems_1_2" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtFamMems_1_3" name="txtFamMems_1_3" className='add-only' /></td>
                        <td className='w-300'><input type='text' id="txtFamMems_1_4" name="txtFamMems_1_4" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='text' id="txtFamMems_2_1" name="txtFamMems_2_1" className='add-only' /></td>
                        <td className='w-125'><input type='text' id="txtFamMems_2_2" name="txtFamMems_2_2" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtFamMems_2_3" name="txtFamMems_2_3" className='add-only' /></td>
                        <td className='w-300'><input type='text' id="txtFamMems_2_4" name="txtFamMems_2_4" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='text' id="txtFamMems_3_1" name="txtFamMems_3_1" className='add-only' /></td>
                        <td className='w-125'><input type='text' id="txtFamMems_3_2" name="txtFamMems_3_2" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtFamMems_3_3" name="txtFamMems_3_3" className='add-only' /></td>
                        <td className='w-300'><input type='text' id="txtFamMems_3_4" name="txtFamMems_3_4" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='text' id="txtFamMems_4_1" name="txtFamMems_4_1" className='add-only' /></td>
                        <td className='w-125'><input type='text' id="txtFamMems_4_2" name="txtFamMems_4_2" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtFamMems_4_3" name="txtFamMems_4_3" className='add-only' /></td>
                        <td className='w-300'><input type='text' id="txtFamMems_4_4" name="txtFamMems_4_4" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='text' id="txtFamMems_5_1" name="txtFamMems_5_1" className='add-only' /></td>
                        <td className='w-125'><input type='text' id="txtFamMems_5_2" name="txtFamMems_5_2" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtFamMems_5_3" name="txtFamMems_5_3" className='add-only' /></td>
                        <td className='w-300'><input type='text' id="txtFamMems_5_4" name="txtFamMems_5_4" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><b>Others Not Listed Above</b></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='text' id="txtFamMems_6_1" name="txtFamMems_6_1" className='add-only' /></td>
                        <td className='w-125'><input type='text' id="txtFamMems_6_2" name="txtFamMems_6_2" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtFamMems_6_3" name="txtFamMems_6_3" className='add-only' /></td>
                        <td className='w-300'><input type='text' id="txtFamMems_6_4" name="txtFamMems_6_4" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='text' id="txtFamMems_7_1" name="txtFamMems_7_1" className='add-only' /></td>
                        <td className='w-125'><input type='text' id="txtFamMems_7_2" name="txtFamMems_7_2" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtFamMems_7_3" name="txtFamMems_7_3" className='add-only' /></td>
                        <td className='w-300'><input type='text' id="txtFamMems_7_4" name="txtFamMems_7_4" className='add-only' /></td>
                    </tr>
                </table>
                <h2>Social Information</h2>
                <span className='small'>(as appropriate)</span>
                <p>
                    <span className='eleHeader'>Primary/Family/Marital/Significant Other Support</span>
                    <span className='small'>(including consumer/family functional strengths and natural and informal supports)</span>
                    <textarea id="txtOtherSupport" name="txtOtherSupport" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Systems After Support</span>
                    <span className='small'>(other support systems)</span>
                    <textarea id="txtSysAfterSupport" name="txtSysAfterSupport" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Barriers/Challenges</span>
                    <textarea id="txtOtherSupport_1" name="txtOtherSupport_1" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Level of Functioning; Relational Issues with Family</span>
                    <span className='small'>(include family's potential involvement with treatment)</span>
                    <textarea id="txtLOF" name="txtLOF" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Barriers/Challenges</span>
                    <textarea id="txtLOF_1" name="txtLOF_1" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Pertinent Family History</span>
                    <span className='small'>(to include family MH and AoD history)</span>
                    <textarea id="txtPrtFamHist" name="txtPrtFamHist" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Barriers/Challenges</span>
                    <textarea id="txtPrtFamHist_1" name="txtPrtFamHist_1" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Strengths/Preferences/Weaknesses/Interests/Skills/Needs</span>
                    <textarea id="txtSPW" name="txtSPW" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Barriers/Challenges</span>
                    <textarea id="txtSPW_1" name="txtSPW_1" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Limitations of Activities of Daily Living/Level of Independence</span>
                    <span className='small'>(include information relating to financial status and ability to manage own finances)</span>
                    <textarea id="txtLevelOfIndep" name="txtLevelOfIndep" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Barriers/Challenges</span>
                    <textarea id="txtLevelOfIndep_1" name="txtLevelOfIndep_1" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Friendship/Social/Peer Support Relationships History</span>
                    <textarea id="txtFriendHistory" name="txtFriendHistory" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Barriers/Challenges</span>
                    <textarea id="txtFriendHistory_1" name="txtFriendHistory_1" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Meaningful Activities Strengths</span>
                    <span className='small'>(community involvement, volunteer activities, leisure/recreation, and other interests)</span>
                    <textarea id="txtMAS" name="txtMAS" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Barriers/Challenges</span>
                    <textarea id="txtMAS_1" name="txtMAS_1" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Community Supports/Self Help Groups History</span>
                    <span className='small'>(AA, NA, NAMIO, etc.)</span>
                    <textarea id="txtCommSupports" name="txtCommSupports" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Barriers/Challenges</span>
                    <textarea id="txtCommSupports_1" name="txtCommSupports_1" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Religion/Spirituality History</span>
                    <textarea id="txtReligHistory" name="txtReligHistory" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Barriers/Challenges</span>
                    <textarea id="txtReligHistory_1" name="txtReligHistory_1" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Cultural/Ethnic History/Issues</span>
                    <textarea id="txtCultural" name="txtCultural" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Barriers/Challenges</span>
                    <textarea id="txtCultural_1" name="txtCultural_1" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Sexual History</span>
                    <span className='small'>(Issues relative to sexual orientation, gender expression, etc.)</span>
                    <textarea id="txtSexHistory" name="txtSexHistory" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Barriers/Challenges</span>
                    <textarea id="txtSexHistory_1" name="txtSexHistory_1" className='add-only'></textarea>
                </p>
                <h2>Education, Developmental Disability, Employment, and Military Information</h2>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Education History</span>
                            <span className='small'>(check all that apply)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbEdHistory_1" name="cbEdHistory" className='add-only' value="1" /> GED</td>
                        <td className='w-250'><input type="checkbox" id="cbEdHistory_2" name="cbEdHistory" className='add-only' value="2" /> HS Grad</td>
                        <td className='w-250'><input type="checkbox" id="cbEdHistory_3" name="cbEdHistory" className='add-only' value="3" /> College Degree/Major</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbEdHistory_4" name="cbEdHistory" className='add-only' value="4" /> None Reported</td>
                        <td className='w-250'><input type="checkbox" id="cbEdHistory_5" name="cbEdHistory" className='add-only' value="5" /> Literacy Level</td>
                        <td className='w-250'><input type="checkbox" id="cbEdHistory_6" name="cbEdHistory" className='add-only' value="6" /> Special School Placement</td>
                    </tr>
                    <tr>
                        <td className='w-500'><input type="checkbox" id="cbEdHistory_7" name="cbEdHistory" className='add-only' value="1" /> IEP - Placed in special classes in high school</td>
                        <td className='w-250'><input type="checkbox" id="cbEdHistory_8" name="cbEdHistory" className='add-only' value="1" /> Assistive Technology</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbEdHistory_9" name="cbEdHistory" className='add-only' value="1" /> Other:
                            <input type='text' id="txtEdHistory_10" name="txtEdHistory_10" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>List Needs</span>
                    <textarea id="txtListNeeds" name="txtListNeeds" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Highest Grade Completed</span>
                            <input type='text' id="txtHighestGrade" name="txtHighestGrade" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Vocational Year Completed</span>
                            <input type='text' id="txtVocYear" name="txtVocYear" className='add-only' />

                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Other Degree</span>
                            <input type='text' id="txtOtherDegree" name="txtOtherDegree" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>No. of Yrs, Qtrs., or Semesters</span>
                            <input type='text' id="txtQtrs" name="txtQtrs" className='add-only' />
                        </td>
                         
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Developmental History</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbDevHistory_1" name="cbDevHistory" className='add-only' value="1" /> Unremarkable</td>
                        <td className='w-250'><input type="checkbox" id="cbDevHistory_2" name="cbDevHistory" className='add-only' value="2" /> Remarkable Unable to Recall</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Prenatal Hx/Complications</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbPrenatalHx_1" name="cbPrenatalHx" className='add-only' value="1" /> No  &nbsp;ne</td>
                        <td className='w-250'><input type="checkbox" id="cbPrenatalHx_2" name="cbPrenatalHx" className='add-only' value="2" /> Alcohol/Drug Use</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPrenatalHx_3" name="cbPrenatalHx" className='add-only' value="3" /> Other:
                            <input type='text' id="txtPrenatalHx_4" name="txtPrenatalHx_4" className='add-only' />
                        </td>
                    </tr>
                </table>
                <h3>Developmental Milestones</h3>
                <span className='small'>(age in months)</span>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>
                                <input type="checkbox" id="cbDevMilestone_1" name="cbDevMilestone_1" className='add-only' value="1" />
                                Babbled
                            </span>
                            <input type='text' id="txtDevMilestone_1" name="txtDevMilestone_1" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>
                                <input type="checkbox" id="cbDevMilestone_2" name="cbDevMilestone_2" className='add-only' value="1" />
                                First Words
                            </span>
                            <input type='text' id="txtDevMilestone_2" name="txtDevMilestone_2" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>
                                <input type="checkbox" id="cbDevMilestone_3" name="cbDevMilestone_3" className='add-only' value="1" />
                                Combined Words
                            </span>
                            <input type='text' id="txtDevMilestone_3" name="txtDevMilestone_3" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbDevMilestone_4" name="cbDevMilestone_4" className='add-only' value="1" /> Unknown
                        </td>
                        <td className='w-500'>
                            <input type="checkbox" id="cbDevMilestone_5" name="cbDevMilestone_5" className='add-only' value="1" /> Met all milestones
                        </td>
                    </tr>
                </table>
                <h3>Gross Motor</h3>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>
                                <input type="checkbox" id="cbGrossMotor_1" name="cbGrossMotor_1" className='add-only' value="1" />
                                Rolled Over
                            </span>
                            <input type='text' id="txtGrossMotor_1" name="txtGrossMotor_1" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>
                                <input type="checkbox" id="cbGrossMotor_2" name="cbGrossMotor_2" className='add-only' value="1" />
                                Sat Up
                            </span>
                            <input type='text' id="txtGrossMotor_2" name="txtGrossMotor_2" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>
                                <input type="checkbox" id="cbGrossMotor_3" name="cbGrossMotor_3" className='add-only' value="1" />
                                Crawled
                            </span>
                            <input type='text' id="txtGrossMotor_3" name="txtGrossMotor_3" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>
                                <input type="checkbox" id="cbGrossMotor_4" name="cbGrossMotor_4" className='add-only' value="1" />
                                Walked
                            </span>
                            <input type='text' id="txtGrossMotor_4" name="txtGrossMotor_4" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>
                                <input type="checkbox" id="cbGrossMotor_5" name="cbGrossMotor_5" className='add-only' value="1" />
                                Toilet Trained
                            </span>
                            <input type='text' id="txtGrossMotor_5" name="txtGrossMotor_5" className='add-only' />
                        </td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbGrossMotor_6" name="cbGrossMotor_6" className='add-only' value="1" /> Unknown
                        </td>
                        <td className='w-500'>
                            <input type="checkbox" id="cbGrossMotor_7" name="cbGrossMotor_7" className='add-only' value="1" /> Met all milestones
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Developmental Disabilities</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbDevDisability_1" name="cbDevDisability" className='add-only' value="1" /> Autism</td>
                        <td className='w-500'>
                            <input type="checkbox" id="cbDevDisability_2" name="cbDevDisability" className='add-only' value="2" /> Traumatic Brain Injury 
                            &nbsp;

                            Date of Injury: <input type='date' id="txtDevDisability_3" name="txtDevDisability" className='add-only w-150 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbDevDisability_4" name="cbDevDisability" className='add-only' value="3" /> Developmental</td>
                        <td className='w-250'><input type="checkbox" id="cbDevDisability_5" name="cbDevDisability" className='add-only' value="4" /> Mental Retardation</td>
                        <td className='w-250'><input type="checkbox" id="cbDevDisability_6" name="cbDevDisability" className='add-only' value="5" /> Mild</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbDevDisability_7" name="cbDevDisability" className='add-only' value="6" /> Moderate</td>
                        <td className='w-250'><input type="checkbox" id="cbDevDisability_8" name="cbDevDisability" className='add-only' value="7" /> Severe</td>
                        <td className='w-250'><input type="checkbox" id="cbDevDisability_9" name="cbDevDisability" className='add-only' value="8" /> Profound</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbDevDisability_10" name="cbDevDisability" className='add-only' value="9" /> Unspecified</td>
                        <td className='w-250'><input type="checkbox" id="cbDevDisability_11" name="cbDevDisability" className='add-only' value="10" /> Down Syndrome</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Delay</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbDevDisability_15" name="cbDevDisability" className='add-only' value="14" /> Cerebral Palsy</td>
                        <td className='w-250'><input type="checkbox" id="cbDevDisability_16" name="cbDevDisability" className='add-only' value="15" /> High Risk Infant</td>
                        <td className='w-250'><input type="checkbox" id="cbDevDisability_17" name="cbDevDisability" className='add-only' value="16" /> Learning Disability</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbDevDisability_18" name="cbDevDisability" className='add-only' value="17" /> Other:
                            <input type='text' id="txtDevDisability_19" name="txtDevDisability_19" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Barriers to Learning</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbLearnBarriers_1" name="cbLearnBarriers" className='add-only' value="1" /> No  &nbsp;ne Reported</td>
                        <td className='w-250'><input type="checkbox" id="cbLearnBarriers_2" name="cbLearnBarriers" className='add-only' value="2" /> Inability to Read/Write</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbLearnBarriers_3" name="cbLearnBarriers" className='add-only' value="17" /> Other:
                            <input type='text' id="txtLearnBarriers_4" name="txtLearnBarriers_4" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Special Communication Needs</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbSpecCommNeeds_1" name="cbSpecCommNeeds" className='add-only' value="1" /> No  &nbsp;ne Reported</td>
                        <td className='w-250'><input type="checkbox" id="cbSpecCommNeeds_2" name="cbSpecCommNeeds" className='add-only' value="2" /> TDD/TTY Device</td>
                        <td className='w-250'><input type="checkbox" id="cbSpecCommNeeds_3" name="cbSpecCommNeeds" className='add-only' value="3" /> Sign Language Interpreter</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbSpecCommNeeds_4" name="cbSpecCommNeeds" className='add-only' value="4" /> Assistive Listening Device(s)</td>
                        <td className='w-500'><input type="checkbox" id="cbSpecCommNeeds_5" name="cbSpecCommNeeds" className='add-only' value="5" /> Language Interpreter Services Needed/ Other Spoken Language</td>
                    </tr>
                </table>
                <h2>Employment, Employment, and Military Information</h2>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Employment</span>
                            <span className='small'>(check all that apply)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbEmp_1" name="cbEmp" className='add-only' value="1" />{`Full Time (35 hrs. or more per week)`} </td>
                        <td className='w-250'><input type="checkbox" id="cbEmp_2" name="cbEmp" className='add-only' value="2" />{` Part Time (< 35 hrs. per week)`} </td>
                        <td className='w-250'><input type="checkbox" id="cbEmp_3" name="cbEmp" className='add-only' value="3" />{` Non-Competitive`} </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbEmp_6" name="cbEmp" className='add-only' value="6" /> Unemployed/Date Last Worked: &nbsp;
                            <input type='date' id="txtEmp_7" name="txtEmp" className='add-only custom-add-only w-250' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Not in Labor Force</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbNoLabor_1" name="cbNoLabor" className='add-only' value="1" /> Disabled</td>
                        <td className='w-250'><input type="checkbox" id="cbNoLabor_2" name="cbNoLabor" className='add-only' value="2" /> Retired</td>
                        <td className='w-250'><input type="checkbox" id="cbNoLabor_3" name="cbNoLabor" className='add-only' value="3" /> Homemaker</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbNoLabor_4" name="cbNoLabor" className='add-only' value="4" /> Student</td>
                        <td className='w-500'><input type="checkbox" id="cbNoLabor_5" name="cbNoLabor" className='add-only' value="5" /> Living in Institution</td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>If Employed, Name of Employer</span>
                    <textarea id="txtEmpName" name="txtEmpName" className='add-only'></textarea>
                </p>
                <h3>Job Performance History</h3>
                <p>
                    <span className='eleHeader'>No. of Jobs in Last 5 Years</span>
                    <input type='text' id="txtNumOfJobs" name="txtNumOfJobs" className='add-only' />

                </p>
                <p>
                    <span className='eleHeader'>Comments</span>
                    <span className='small'>(include performance/behavioral problems due to AoD use)</span>
                    <textarea id="txtJobComments" name="txtJobComments" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Attendance</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type="checkbox" id="cbJobAttend_1" name="cbJobAttend" className='add-only' value="1" /> Above Average</td>
                        <td className='w-187'><input type="checkbox" id="cbJobAttend_2" name="cbJobAttend" className='add-only' value="2" /> Normal</td>
                        <td className='w-187'><input type="checkbox" id="cbJobAttend_3" name="cbJobAttend" className='add-only' value="3" /> Tardiness</td>
                        <td className='w-187'><input type="checkbox" id="cbJobAttend_4" name="cbJobAttend" className='add-only' value="4" /> Absenteeism</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Performance</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type="checkbox" id="cbJobPerf_1" name="cbJobPerf" className='add-only' value="1" /> Exemplary</td>
                        <td className='w-187'><input type="checkbox" id="cbJobPerf_2" name="cbJobPerf" className='add-only' value="2" /> Good</td>
                        <td className='w-187'><input type="checkbox" id="cbJobPerf_3" name="cbJobPerf" className='add-only' value="3" /> Average</td>
                        <td className='w-187'><input type="checkbox" id="cbJobPerf_4" name="cbJobPerf" className='add-only' value="4" /> Below Average</td>
                    </tr>
                </table>
                <h3>Employment Interests/Skills</h3>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Is client satisfied with job?</span>
                            <input type="checkbox" id="cbJobSatisfied_1" name="cbJobSatisfied" className='add-only' value="1" /> NA &nbsp;
                            <input type="checkbox" id="cbJobSatisfied_2" name="cbJobSatisfied" className='add-only' value="2" /> No &nbsp;
                            <input type="checkbox" id="cbJobSatisfied_3" name="cbJobSatisfied" className='add-only' value="3" /> Yes &nbsp;
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>(If not currently employed) Client wants to work?</span>
                            <input type="checkbox" id="cbJobWants_1" name="cbJobWants" className='add-only' value="2" /> No &nbsp;
                            <input type="checkbox" id="cbJobWants_2" name="cbJobWants" className='add-only' value="3" /> Yes &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Is client experiencing financial problems?</span>
                            <input type="checkbox" id="cbJobFinancialPx_1" name="cbJobFinancialPx" className='add-only' value="1" /> No  &nbsp;
                            <input type="checkbox" id="cbJobFinancialPx_2" name="cbJobFinancialPx" className='add-only' value="2" /> Yes &nbsp;
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Is client concerned that employment will affect benefits?</span>
                            <input type="checkbox" id="cbJobBenefits_1" name="cbJobBenefits" className='add-only' value="1" /> No  &nbsp;
                            <input type="checkbox" id="cbJobBenefits_2" name="cbJobBenefits" className='add-only' value="2" /> Yes &nbsp;
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Comments on Past or Current Employment/Education Skills/Interests/Strengths</span>
                    <span className='small'>(include information relating to past or current employment/education skills and interests)</span>
                    <textarea id="txtJobEEIS" name="txtJobEEIS" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Allergies and/or Food/Drug Reactions</span>
                            <input type="checkbox" id="cbAllergies_1" name="cbAllergies" className='add-only' value="1" /> None Reported &nbsp;
                            <input type="checkbox" id="cbAllergies_2" name="cbAllergies" className='add-only' value="2" /> No &nbsp;
                            <input type="checkbox" id="cbAllergies_3" name="cbAllergies" className='add-only' value="3" /> Yes &nbsp;
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>If Yes to Allergies/Reactions, Symptoms</span>
                    <textarea id="txtAllergySymptons" name="txtAllergySymptons" className='add-only'></textarea>
                </p>
                <h2>Alcohol/Drug Abuse History</h2>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Illegal drug use/abuse past 12 months?</span>
                            <input type="checkbox" id="cbIllegalDrugUse_1" name="cbIllegalDrugUse" className='add-only' value="1" /> No  &nbsp;
                            <input type="checkbox" id="cbIllegalDrugUse_2" name="cbIllegalDrugUse" className='add-only' value="2" /> Yes
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Prescription drug abuse past 12 months?</span>
                            <input type="checkbox" id="cbRxDrugUse_1" name="cbRxDrugUse" className='add-only' value="1" /> No  &nbsp;
                            <input type="checkbox" id="cbRxDrugUse_2" name="cbRxDrugUse" className='add-only' value="2" /> Yes
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Non-prescription drug abuse past 12 months?</span>
                            <input type="checkbox" id="cbNonRxDrugUse_1" name="cbNonRxDrugUse" className='add-only' value="1" /> No  &nbsp;
                            <input type="checkbox" id="cbNonRxDrugUse_2" name="cbNonRxDrugUse" className='add-only' value="2" /> Yes
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Alcohol abuse past 12 months?</span>
                            <input type="checkbox" id="cbAlcoholAbuse_1" name="cbAlcoholAbuse" className='add-only' value="1" /> No  &nbsp;
                            <input type="checkbox" id="cbAlcoholAbuse_2" name="cbAlcoholAbuse" className='add-only' value="2" /> Yes
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Substance Abuse Related Withdrawal Symptoms</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type="checkbox" id="cbWithdrawal_1" name="cbWithdrawal" className='add-only' value="1" /> NA</td>
                        <td className='w-187'><input type="checkbox" id="cbWithdrawal_2" name="cbWithdrawal" className='add-only' value="2" /> Sweating</td>
                        <td className='w-187'><input type="checkbox" id="cbWithdrawal_3" name="cbWithdrawal" className='add-only' value="3" /> Cravings</td>
                        <td className='w-187'><input type="checkbox" id="cbWithdrawal_4" name="cbWithdrawal" className='add-only' value="4" /> Tremulousness</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type="checkbox" id="cbWithdrawal_5" name="cbWithdrawal" className='add-only' value="5" /> Rapid Heart Rate</td>
                        <td className='w-187'><input type="checkbox" id="cbWithdrawal_6" name="cbWithdrawal" className='add-only' value="6" /> Hallucinations</td>
                        <td className='w-187'><input type="checkbox" id="cbWithdrawal_7" name="cbWithdrawal" className='add-only' value="7" /> Nausea</td>
                        <td className='w-187'>&nbsp;</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-125'><span className='eleHeader'>Substance</span></td>
                        <td className='w-75'><span className='eleHeader'>1st Use Age</span></td>
                        <td className='w-150'><span className='eleHeader'>Last Use Date</span></td>
                        <td className='w-100'><span className='eleHeader'>Use Freq</span></td>
                        <td className='w-150'><span className='eleHeader'>Amount</span></td>
                        <td className='w-150'><span className='eleHeader'>Method</span></td>
                    </tr>
                    <tr>
                        <td className='w-125'>Alcohol</td>
                        <td className='w-75'><input type='text' id="txtSA_1_1" name="txtSA_1_1" className='add-only' /></td>
                        <td className='w-150'><input type='date' id="txtSA_1_2" name="txtSA_1_2" className='add-only' /></td>
                        <td className='w-100'><input type='text' id="txtSA_1_3" name="txtSA_1_3" className='add-only' /></td>
                        <td className='w-150'><input type='text' id="txtSA_1_4" name="txtSA_1_4" className='add-only' /></td>
                        <td className='w-150'><input type='text' id="txtSA_1_5" name="txtSA_1_5" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-125'>Marijuana</td>
                        <td className='w-75'><input type='text' id="txtSA_2_1" name="txtSA_2_1" className='add-only' /></td>
                        <td className='w-150'><input type='date' id="txtSA_2_2" name="txtSA_2_2" className='add-only' /></td>
                        <td className='w-100'><input type='text' id="txtSA_2_3" name="txtSA_2_3" className='add-only' /></td>
                        <td className='w-150'><input type='text' id="txtSA_2_4" name="txtSA_2_4" className='add-only' /></td>
                        <td className='w-150'><input type='text' id="txtSA_2_5" name="txtSA_2_5" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-125'>Cocaine/Crack</td>
                        <td className='w-75'><input type='text' id="txtSA_3_1" name="txtSA_3_1" className='add-only' /></td>
                        <td className='w-150'><input type='date' id="txtSA_3_2" name="txtSA_3_2" className='add-only' /></td>
                        <td className='w-100'><input type='text' id="txtSA_3_3" name="txtSA_3_3" className='add-only' /></td>
                        <td className='w-150'><input type='text' id="txtSA_3_4" name="txtSA_3_4" className='add-only' /></td>
                        <td className='w-150'><input type='text' id="txtSA_3_5" name="txtSA_3_5" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-125'>Amphetamines</td>
                        <td className='w-75'><input type='text' id="txtSA_4_1" name="txtSA_4_1" className='add-only' /></td>
                        <td className='w-150'><input type='date' id="txtSA_4_2" name="txtSA_4_2" className='add-only' /></td>
                        <td className='w-100'><input type='text' id="txtSA_4_3" name="txtSA_4_3" className='add-only' /></td>
                        <td className='w-150'><input type='text' id="txtSA_4_4" name="txtSA_4_4" className='add-only' /></td>
                        <td className='w-150'><input type='text' id="txtSA_4_5" name="txtSA_4_5" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-125'>Hallucinogens</td>
                        <td className='w-75'><input type='text' id="txtSA_5_1" name="txtSA_5_1" className='add-only' /></td>
                        <td className='w-150'><input type='date' id="txtSA_5_2" name="txtSA_5_2" className='add-only' /></td>
                        <td className='w-100'><input type='text' id="txtSA_5_3" name="txtSA_5_3" className='add-only' /></td>
                        <td className='w-150'><input type='text' id="txtSA_5_4" name="txtSA_5_4" className='add-only' /></td>
                        <td className='w-150'><input type='text' id="txtSA_5_5" name="txtSA_5_5" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-125'>Ecstasy/Other</td>
                        <td className='w-75'><input type='text' id="txtSA_6_1" name="txtSA_6_1" className='add-only' /></td>
                        <td className='w-150'><input type='date' id="txtSA_6_2" name="txtSA_6_2" className='add-only' /></td>
                        <td className='w-100'><input type='text' id="txtSA_6_3" name="txtSA_6_3" className='add-only' /></td>
                        <td className='w-150'><input type='text' id="txtSA_6_4" name="txtSA_6_4" className='add-only' /></td>
                        <td className='w-150'><input type='text' id="txtSA_6_5" name="txtSA_6_5" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-125'>Inhalants</td>
                        <td className='w-75'><input type='text' id="txtSA_7_1" name="txtSA_7_1" className='add-only' /></td>
                        <td className='w-150'><input type='date' id="txtSA_7_2" name="txtSA_7_2" className='add-only' /></td>
                        <td className='w-100'><input type='text' id="txtSA_7_3" name="txtSA_7_3" className='add-only' /></td>
                        <td className='w-150'><input type='text' id="txtSA_7_4" name="txtSA_7_4" className='add-only' /></td>
                        <td className='w-150'><input type='text' id="txtSA_7_5" name="txtSA_7_5" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-125'>Heroin</td>
                        <td className='w-75'><input type='text' id="txtSA_8_1" name="txtSA_8_1" className='add-only' /></td>
                        <td className='w-150'><input type='date' id="txtSA_8_2" name="txtSA_8_2" className='add-only' /></td>
                        <td className='w-100'><input type='text' id="txtSA_8_3" name="txtSA_8_3" className='add-only' /></td>
                        <td className='w-150'><input type='text' id="txtSA_8_4" name="txtSA_8_4" className='add-only' /></td>
                        <td className='w-150'><input type='text' id="txtSA_8_5" name="txtSA_8_5" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-125'>Benzodiazepines</td>
                        <td className='w-75'><input type='text' id="txtSA_9_1" name="txtSA_9_1" className='add-only' /></td>
                        <td className='w-150'><input type='date' id="txtSA_9_2" name="txtSA_9_2" className='add-only' /></td>
                        <td className='w-100'><input type='text' id="txtSA_9_3" name="txtSA_9_3" className='add-only' /></td>
                        <td className='w-150'><input type='text' id="txtSA_9_4" name="txtSA_9_4" className='add-only' /></td>
                        <td className='w-150'><input type='text' id="txtSA_9_5" name="txtSA_9_5" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-125'>Sedatives</td>
                        <td className='w-75'><input type='text' id="txtSA_10_1" name="txtSA_10_1" className='add-only' /></td>
                        <td className='w-150'><input type='date' id="txtSA_10_2" name="txtSA_10_2" className='add-only' /></td>
                        <td className='w-100'><input type='text' id="txtSA_10_3" name="txtSA_10_3" className='add-only' /></td>
                        <td className='w-150'><input type='text' id="txtSA_10_4" name="txtSA_10_4" className='add-only' /></td>
                        <td className='w-150'><input type='text' id="txtSA_10_5" name="txtSA_10_5" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-125'>Tranquilizers</td>
                        <td className='w-75'><input type='text' id="txtSA_11_1" name="txtSA_11_1" className='add-only' /></td>
                        <td className='w-150'><input type='date' id="txtSA_11_2" name="txtSA_11_2" className='add-only' /></td>
                        <td className='w-100'><input type='text' id="txtSA_11_3" name="txtSA_11_3" className='add-only' /></td>
                        <td className='w-150'><input type='text' id="txtSA_11_4" name="txtSA_11_4" className='add-only' /></td>
                        <td className='w-150'><input type='text' id="txtSA_11_5" name="txtSA_11_5" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-125'>Opiates </td>
                        <td className='w-75'><input type='text' id="txtSA_12_1" name="txtSA_12_1" className='add-only' /></td>
                        <td className='w-150'><input type='date' id="txtSA_12_2" name="txtSA_12_2" className='add-only' /></td>
                        <td className='w-100'><input type='text' id="txtSA_12_3" name="txtSA_12_3" className='add-only' /></td>
                        <td className='w-150'><input type='text' id="txtSA_12_4" name="txtSA_12_4" className='add-only' /></td>
                        <td className='w-150'><input type='text' id="txtSA_12_5" name="txtSA_12_5" className='add-only' /></td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Means of Obtaining Substance</span>
                    <textarea id="txtMeansObtain" name="txtMeansObtain" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Motivation for use</span>
                    <textarea id="txtUseMotivation" name="txtUseMotivation" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Interest in reducing use and attaining abstinence</span>
                    <textarea id="txtReduceInterest" name="txtReduceInterest" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Problems usage may have caused</span>
                    <textarea id="txtCausedProblems" name="txtCausedProblems" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Check all that apply</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type="checkbox" id="cbSAApply_1" name="cbSAApply" className='add-only' value="1" /> DWI</td>
                        <td className='w-187'><input type="checkbox" id="cbSAApply_2" name="cbSAApply" className='add-only' value="2" /> Blackouts</td>
                        <td className='w-187'><input type="checkbox" id="cbSAApply_3" name="cbSAApply" className='add-only' value="3" /> Absenteeism</td>
                        <td className='w-187'><input type="checkbox" id="cbSAApply_4" name="cbSAApply" className='add-only' value="4" /> Seizures</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type="checkbox" id="cbSAApply_5" name="cbSAApply" className='add-only' value="5" /> Job Loss</td>
                        <td className='w-187'><input type="checkbox" id="cbSAApply_6" name="cbSAApply" className='add-only' value="6" /> IV Drug Use</td>
                        <td className='w-187'><input type="checkbox" id="cbSAApply_7" name="cbSAApply" className='add-only' value="7" /> Pregnant</td>
                        <td className='w-187'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Stages of Change</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type="checkbox" id="cbSAStagesChange_1" name="cbSAStagesChange" className='add-only' value="1" /> Precontemplation</td>
                        <td className='w-187'><input type="checkbox" id="cbSAStagesChange_2" name="cbSAStagesChange" className='add-only' value="2" /> Contemplation</td>
                        <td className='w-187'><input type="checkbox" id="cbSAStagesChange_3" name="cbSAStagesChange" className='add-only' value="3" /> Preparation</td>
                        <td className='w-187'><input type="checkbox" id="cbSAStagesChange_4" name="cbSAStagesChange" className='add-only' value="4" /> Action</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type="checkbox" id="cbSAStagesChange_5" name="cbSAStagesChange" className='add-only' value="5" /> Maintenance</td>
                        <td className='w-187'><input type="checkbox" id="cbSAStagesChange_6" name="cbSAStagesChange" className='add-only' value="6" /> Relapse</td>
                        <td className='w-187'>&nbsp;</td>
                        <td className='w-187'>&nbsp;</td>
                    </tr>
                </table>
                <h3>ASAM CRITERIA</h3>
                <span className='small'>Please select the appropriate level</span>
                <p>
                    <input type="checkbox" id="cbASAM_1" name="cbASAM" className='add-only' value="1" /> NA<br />
                    <input type="checkbox" id="cbASAM_2" name="cbASAM" className='add-only' value="2" /> <b>Level 0.5</b> - Early Intervention<br />
                    <input type="checkbox" id="cbASAM_3" name="cbASAM" className='add-only' value="3" /> <b>Level 1</b> - Outpatient Services<br />
                    <input type="checkbox" id="cbASAM_4" name="cbASAM" className='add-only' value="4" /> <b>Level 2.1</b> - Intensive Outpatient Services (SAIOP)<br />
                    <input type="checkbox" id="cbASAM_5" name="cbASAM" className='add-only' value="5" /> <b>Level 2.5</b> - Partial Hospitalization Services (SACOT)<br />
                    <input type="checkbox" id="cbASAM_6" name="cbASAM" className='add-only' value="6" /> <b>Level 3.1</b> - Clinically Managed, Low-Intensity Residential Services<br />
                    <input type="checkbox" id="cbASAM_7" name="cbASAM" className='add-only' value="7" /> <b>Level 3.3</b> - Clinically Managed Population-Specific, High-Intensity Residential services<br />
                    <input type="checkbox" id="cbASAM_8" name="cbASAM" className='add-only' value="8" /> <b>Level 3.5</b> - Clinically Manage High-Intensity Residential Services (Adult Criteria)<br />
                    <input type="checkbox" id="cbASAM_9" name="cbASAM" className='add-only' value="9" /> <b>Level 3.7</b> - Medically Monitored Intensive Inpatient Services (Adult Criteria)<br />
                    <input type="checkbox" id="cbASAM_10" name="cbASAM" className='add-only' value="10" /> <b>Level 3.9</b> - Medically Monitored/Managed Intensive Inpatient Services<br />
                    <input type="checkbox" id="cbASAM_11" name="cbASAM" className='add-only' value="11" /> <b>Level 4.0</b> - Medically Managed Intensive Inpatient Services<br />
                </p>
                <p>** Lack of availability of appropriate, criteria-selected care and/or poor outcomes at a given level of care warrant a reassessment of the treatment plan with a view to modify the treatment approach.</p>
                <h3>American Society for Addition Medicine (ASAM) Criteria</h3>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Dimension 1. Detoxification/Withdrawal potential</span>
                            <select id="ddlDim1" name="ddlDim1" className='add-only'>
                                <option value="0"></option>
                                <option value="1">High</option>
                                <option value="2">Medium</option>
                                <option value="3">Low</option>
                            </select>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Dimension 2. Medical conditions & complication</span>
                            <select id="ddlDim2" name="ddlDim2" className='add-only'>
                                <option value="0"></option>
                                <option value="1">High</option>
                                <option value="2">Medium</option>
                                <option value="3">Low</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Dimension 3. Emotional/behavioral conditions & complications</span>
                            <select id="ddlDim3" name="ddlDim3" className='add-only'>
                                <option value="0"></option>
                                <option value="1">High</option>
                                <option value="2">Medium</option>
                                <option value="3">Low</option>
                            </select>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Dimension 4. Treatment acceptance/resistance</span>
                            <select id="ddlDim4" name="ddlDim4" className='add-only'>
                                <option value="0"></option>
                                <option value="1">High</option>
                                <option value="2">Medium</option>
                                <option value="3">Low</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Dimension 5. Relapse/continues use potential</span>
                            <select id="ddlDim5" name="ddlDim5" className='add-only'>
                                <option value="0"></option>
                                <option value="1">High</option>
                                <option value="2">Medium</option>
                                <option value="3">Low</option>
                            </select>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Dimension 6. Recovery environment</span>
                            <select id="ddlDim6" name="ddlDim6" className='add-only'>
                                <option value="0"></option>
                                <option value="1">High</option>
                                <option value="2">Medium</option>
                                <option value="3">Low</option>
                            </select>
                        </td>
                    </tr>
                </table>
                <h3>AoD Treatment</h3>
                <p><input type="checkbox" id="cbAOD_1" name="cbAOD_1" className='add-only' value="1" /> No  &nbsp;ne Reported</p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Current</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbSAStages_1" name="cbSAStages" className='add-only' value="1" /> OP</td>
                        <td className='w-250'><input type="checkbox" id="cbSAStages_2" name="cbSAStages" className='add-only' value="2" /> IOP</td>
                        <td className='w-250'><input type="checkbox" id="cbSAStages_3" name="cbSAStages" className='add-only' value="3" /> Residential</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbSAStages_4" name="cbSAStages" className='add-only' value="4" /> Others:
                            <input type='text' id="txtSAStages_5" name="txtSAStages_5" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Past</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbSAStages_6" name="cbSAStages" className='add-only' value="6" /> OP</td>
                        <td className='w-250'><input type="checkbox" id="cbSAStages_7" name="cbSAStages" className='add-only' value="7" /> IOP</td>
                        <td className='w-250'><input type="checkbox" id="cbSAStages_8" name="cbSAStages" className='add-only' value="8" /> Residential</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbSAStages_9" name="cbSAStages" className='add-only' value="9" /> Hospital</td>
                        <td className='w-250'><input type="checkbox" id="cbSAStages_10" name="cbSAStages" className='add-only' value="10" /> Detox</td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSAStages_11" name="cbSAStages" className='add-only' value="11" /> Others:
                            <input type='text' id="txtSAStages_12" name="txtSAStages_12" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p>If current or past, complete the following:</p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Name of Provider Agency</span>
                            <input type='text' id="txtProvAgency" name="txtProvAgency" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Type of Service</span>
                            <input type='text' id="txtTypeOfService" name="txtTypeOfService" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Date of Service</span>
                            <input type='date' id="txtServiceDate" name="txtServiceDate" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Response to Substance Abuse/Use and Other Addictive</span>
                    <span className='small'>(most or least helpful/barriers)</span>
                    <textarea id="txtResponseSA" name="txtResponseSA" className='add-only'></textarea>
                </p>
                <h2>Legal History</h2>
                <p>
                    <span className='eleHeader'>Legal Guardian/Custodian</span>
                    <span className='small'>(include Name, Address, and Phone Number of Legal Guardian/Custodian)</span>
                    <textarea id="txtLegalGuardian" name="txtLegalGuardian" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Does the client need a Guardian/Advocate?</span>
                            <input type="checkbox" id="cbNeedGuardian_1" name="cbNeedGuardian" className='add-only' value="1" /> Yes &nbsp;
                            <input type="checkbox" id="cbNeedGuardian_2" name="cbNeedGuardian" className='add-only' value="2" /> No
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Advance Directive?</span>
                            <input type="checkbox" id="cbAdvDir_1" name="cbAdvDir" className='add-only' value="1" /> Yes &nbsp;
                            <input type="checkbox" id="cbAdvDir_2" name="cbAdvDir" className='add-only' value="2" /> No
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Current Legal Status</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type="checkbox" id="cbLegalStatus_1" name="cbLegalStatus" className='add-only' value="1" /> No  &nbsp;ne Reported</td>
                        <td className='w-187'><input type="checkbox" id="cbLegalStatus_2" name="cbLegalStatus" className='add-only' value="2" /> On Probation</td>
                        <td className='w-187'><input type="checkbox" id="cbLegalStatus_3" name="cbLegalStatus" className='add-only' value="3" /> Detention</td>
                        <td className='w-187'><input type="checkbox" id="cbLegalStatus_4" name="cbLegalStatus" className='add-only' value="4" /> On Parole</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type="checkbox" id="cbLegalStatus_5" name="cbLegalStatus" className='add-only' value="5" /> Awaiting Charge</td>
                        <td className='w-187'><input type="checkbox" id="cbLegalStatus_6" name="cbLegalStatus" className='add-only' value="6" /> AoD Related Legal Problems</td>
                        <td className='w-187'><input type="checkbox" id="cbLegalStatus_7" name="cbLegalStatus" className='add-only' value="7" /> Conditional Release</td>
                        <td className='w-187'><input type="checkbox" id="cbLegalStatus_8" name="cbLegalStatus" className='add-only' value="8" /> Outpatient Commitment</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type="checkbox" id="cbLegalStatus_9" name="cbLegalStatus" className='add-only' value="5" /> Court Ordered to Treatment</td>
                        <td className='w-750'>
                            <input type="checkbox" id="cbLegalStatus_10" name="cbLegalStatus" className='add-only' value="6" /> Others:
                            <input type='text' id="txtLegalStatus_11" name="txtLegalStatus_11" className='add-only' />
                        </td>
                    </tr>
                </table>
                <h3>History of Legal Charges</h3>
                <p><input type="checkbox" id="cbHxOfLegal_1" name="cbHxOfLegal_1" className='add-only' value="1" /> No  &nbsp;ne Reported</p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Juvenile</span>
                            <input type="checkbox" id="cbHxLegalJuvenile_1" name="cbHxLegalJuvenile" className='add-only' value="1" /> Yes &nbsp;
                            <input type="checkbox" id="cbHxLegalJuvenile_2" name="cbHxLegalJuvenile" className='add-only' value="2" /> No
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Adult</span>
                            <input type="checkbox" id="cbLegalAdult_1" name="cbLegalAdult" className='add-only' value="1" /> Yes &nbsp;
                            <input type="checkbox" id="cbLegalAdult_2" name="cbLegalAdult" className='add-only' value="2" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>If yes to Juvenile</span>
                            <input type="checkbox" id="cbLegalJuvenile_1" name="cbLegalJuvenile_1" className='add-only' value="1" /> Status Offense (e.g., Unruly)
                            <input type="checkbox" id="cbLegalJuvenile_2" name="LegalJuvenile_1" className='add-only' value="2" /> Delinquency
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>If yes to Adult</span>
                            <input type="checkbox" id="cbLegalAdult_Yes_1" name="cbLegalAdult_1" className='add-only' value="1" /> Misdemeanor
                            <input type="checkbox" id="cbLegalAdult_No_2" name="cbLegalAdult_1" className='add-only' value="2" /> Felony
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>List and Date Most Recent Legal Charges/Convictions/Incarcerations</span>
                    <textarea id="txtMostRecentLegal" name="txtMostRecentLegal" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Incarcerations</span>
                    <input type="checkbox" id="cbIncarcerations_1" name="cbIncarcerations_1" className='add-only' value="1" /> No  &nbsp;ne Reported<br />
                    <textarea id="txtIncarcerations" name="txtIncarcerations" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Name and Phone No. of Probation/Parole Officer</span>
                    <textarea id="txtPOInfo" name="txtPOInfo" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Civil Proceedings</span>
                    <input type="checkbox" id="cbCivilProceed_1" name="cbCivilProceed_1" className='add-only' value="1" /> No  &nbsp;ne Reported<br />
                    <textarea id="txtCivilProceed" name="txtCivilProceed" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Domestic Relations Court Problems</span>
                    <span className='small'>(i.e., custody, protective services, restraining order)</span>
                    <textarea id="txtDRCourt" name="txtDRCourt" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Current Juvenile Court Involvement</span>
                    <span className='small'>(related to child abuse, neglect, or dependency) </span>
                    <input type="checkbox" id="cbCurrJC_1" name="cbCurrJC_1" className='add-only' value="1" /> No  &nbsp;
                    <input type="checkbox" id="cbCurrJC_2" name="cbCurrJC_1" className='add-only' value="2" /> Yes<br />
                    Comments<br />
                    <textarea id="txtCurrJC" name="txtCurrJC" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Past Juvenile Court Involvement</span>
                    <span className='small'>(related to child abuse, neglect, or dependency)</span>
                    <input type="checkbox" id="cbPastJC_1" name="cbPastJC_1" className='add-only' value="1" /> No  &nbsp;
                    <input type="checkbox" id="cbPastJC_2" name="cbPastJC_2" className='add-only' value="2" /> Yes<br />
                    Comments<br />
                    <textarea id="txtPastJC" name="txtPastJC" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Child Support Enforcement Orders </span>
                            <input type="checkbox" id="cbCSEO_1" name="cbCSEO" className='add-only' value="1" /> Yes &nbsp;
                            <input type="checkbox" id="cbCSEO_2" name="cbCSEO" className='add-only' value="2" /> No
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Children's Protective Services Involvement with Family </span>
                            <input type="checkbox" id="cbCPSI_1" name="cbCPSI" className='add-only' value="1" /> Yes &nbsp;
                            <input type="checkbox" id="cbCPSI_2" name="cbCPSI" className='add-only' value="2" /> No
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Name of Children's Protective Services Caseworker(s) Assigned to Family</span>
                    <span className='small'>(if applicable)</span>
                    <textarea id="txtNameCPSC" name="txtNameCPSC" className='add-only'></textarea>
                </p>
                <h2>Abuse History</h2>
                <span className='small'>(describe in comments section each element checked)</span>
                <table>
                    <tr>
                        <td className='w-187'><input type="checkbox" id="cbAbuseHx_1" name="cbAbuseHx" className='add-only' value="1" /> No  &nbsp; Self Reported History</td>
                        <td className='w-187'><input type="checkbox" id="cbAbuseHx_2" name="cbAbuseHx" className='add-only' value="2" /> Physical Abuse</td>
                        <td className='w-187'><input type="checkbox" id="cbAbuseHx_3" name="cbAbuseHx" className='add-only' value="3" /> Domestic Violence/Abuse</td>
                        <td className='w-187'><input type="checkbox" id="cbAbuseHx_4" name="cbAbuseHx" className='add-only' value="4" /> Community Violence</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type="checkbox" id="cbAbuseHx_5" name="cbAbuseHx" className='add-only' value="5" /> Physical Neglect</td>
                        <td className='w-187'><input type="checkbox" id="cbAbuseHx_6" name="cbAbuseHx" className='add-only' value="6" /> Emotional Abuse</td>
                        <td className='w-187'><input type="checkbox" id="cbAbuseHx_7" name="cbAbuseHx" className='add-only' value="7" /> Elder Abuse</td>
                        <td className='w-187'><input type="checkbox" id="cbAbuseHx_8" name="cbAbuseHx" className='add-only' value="8" /> Sexual Abuse/Molestation</td>
                    </tr>
                </table>
                <p>
                    <input type="checkbox" id="cbAbuseHx_9" name="cbAbuseHx" className='add-only' value="9" /> Other<br />
                    <textarea id="txtAbuseHx_10" name="txtAbuseHx_10" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Comments</span>
                    <span className='small'>(identify if client was/is a victim of abuse or a perpetrator or both)</span>
                    <textarea id="txtAbuseComments" name="txtAbuseComments" className='add-only'></textarea>
                </p>
                <h2>Problem Checklist Including Functional Domains</h2>
                <span className='small'>(Check All Current Problems and list As Evidenced By)</span>
                <p>
                    <span className='eleHeader'>
                        <input type="checkbox" id="cbProblems_1" name="cbProblems" className='add-only' value="1" />
                        Nutritional/Eating Pattern Changes/Diet/Disorders
                    </span>
                    <textarea id="txtProblems_1" name="txtProblems_1" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>
                        <input type="checkbox" id="cbProblems_2" name="cbProblems" className='add-only' value="2" />
                        Pain Management
                    </span>
                    <textarea id="txtProblems_2" name="txtProblems_2" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>
                        <input type="checkbox" id="cbProblems_3" name="cbProblems" className='add-only' value="3" />
                        Depressed Mood/Sad
                    </span>
                    <textarea id="txtProblems_3" name="txtProblems_3" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>
                        <input type="checkbox" id="cbProblems_4" name="cbProblems" className='add-only' value="4" />
                        Bereavement Issues
                    </span>
                    <textarea id="txtProblems_4" name="txtProblems_4" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>
                        <input type="checkbox" id="cbProblems_5" name="cbProblems" className='add-only' value="5" />
                        Anxiety
                    </span>
                    <textarea id="txtProblems_5" name="txtProblems_5" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>
                        <input type="checkbox" id="cbProblems_6" name="cbProblems" className='add-only' value="6" />
                        Traumatic Stress
                    </span>
                    <textarea id="txtProblems_6" name="txtProblems_6" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>
                        <input type="checkbox" id="cbProblems_7" name="cbProblems" className='add-only' value="7" />
                        Anger/Aggression
                    </span>
                    <textarea id="txtProblems_7" name="txtProblems_7" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>
                        <input type="checkbox" id="cbProblems_8" name="cbProblems" className='add-only' value="8" />
                        Oppositional Behaviors
                    </span>
                    <textarea id="txtProblems_8" name="txtProblems_8" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>
                        <input type="checkbox" id="cbProblems_9" name="cbProblems" className='add-only' value="9" />
                        Inattention
                    </span>
                    <textarea id="txtProblems_9" name="txtProblems_9" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>
                        <input type="checkbox" id="cbProblems_10" name="cbProblems" className='add-only' value="10" />
                        Impulsivity
                    </span>
                    <textarea id="txtProblems_10" name="txtProblems_10" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>
                        <input type="checkbox" id="cbProblems_11" name="cbProblems" className='add-only' value="11" />
                        Disturbed Reality Contact (psychosis)
                    </span>
                    <textarea id="txtProblems_11" name="txtProblems_11" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>
                        <input type="checkbox" id="cbProblems_12" name="cbProblems" className='add-only' value="12" />
                        Mood Swings/Hyperactivity
                    </span>
                    <textarea id="txtProblems_12" name="txtProblems_12" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>
                        <input type="checkbox" id="cbProblems_14" name="cbProblems" className='add-only' value="14" />
                        Substance Use/Addiction
                    </span>
                    <textarea id="txtProblems_14" name="txtProblems_14" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>
                        <input type="checkbox" id="cbProblems_15" name="cbProblems" className='add-only' value="15" />
                        Other Addictive Behaviors/Risk-Taking Behaviors
                    </span>
                    <textarea id="txtProblems_15" name="txtProblems_15" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>
                        <input type="checkbox" id="cbProblems_16" name="cbProblems" className='add-only' value="16" />
                        Sleep Problems
                    </span>
                    <textarea id="txtProblems_16" name="txtProblems_16" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>
                        <input type="checkbox" id="cbProblems_17" name="cbProblems" className='add-only' value="17" />
                        Psychosocial Stressors
                    </span>
                    <textarea id="txtProblems_17" name="txtProblems_17" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>
                        <input type="checkbox" id="cbProblems_18" name="cbProblems" className='add-only' value="18" />
                        Pertinent Health Issues/Medical History
                    </span>
                    <span className='small'>(Vision, Hearing, Teeth, Skin, Seizures)</span>
                    <textarea id="txtProblems_18" name="txtProblems_18" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>
                        <input type="checkbox" id="cbProblems_19" name="cbProblems" className='add-only' value="19" />
                        Adjustment to disabilities and/or disorder
                    </span>
                    <textarea id="txtProblems_19" name="txtProblems_19" className='add-only'></textarea>
                </p>
                <h2>Mental Status Exam </h2>
                <span className='small'>(Check when appropriate)</span>
                <h3>General Observations</h3>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Appearance</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_1_1" name="cpGO_1_1" className='add-only' value="1" /> Well Groomed
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_1_2" name="cpGO_1_2" className='add-only' value="1" /> Unkempt
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_1_3" name="cpGO_1_3" className='add-only' value="1" /> Disheveled
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_1_4" name="cpGO_1_4" className='add-only' value="1" /> Appropriate
                        </td>
                         
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Build</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_2_1" name="cpGO_2_1" className='add-only' value="1" /> Average
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_2_2" name="cpGO_2_2" className='add-only' value="1" /> Thin
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_2_3" name="cpGO_2_3" className='add-only' value="1" /> Overweight
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Demeanor</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_3_1" name="cpGO_3_1" className='add-only' value="1" /> Average
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_3_2" name="cpGO_3_2" className='add-only' value="1" /> Hostile
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_3_3" name="cpGO_3_3" className='add-only' value="1" /> Mistrustful
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_3_4" name="cpGO_3_4" className='add-only' value="1" /> Withdrawn
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_3_5" name="cpGO_3_5" className='add-only' value="1" /> Preoccupied
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_3_6" name="cpGO_3_6" className='add-only' value="1" /> Demanding
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Eye Contact</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_4_1" name="cpGO_4_1" className='add-only' value="1" /> Average
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_4_2" name="cpGO_4_2" className='add-only' value="1" /> Avoidant
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_4_3" name="cpGO_4_3" className='add-only' value="1" /> Intense
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Activity</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_5_1" name="cpGO_5_1" className='add-only' value="1" /> Average
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_5_2" name="cpGO_5_2" className='add-only' value="1" /> Agitated
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_5_3" name="cpGO_5_3" className='add-only' value="1" /> Slowed
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Speech</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_6_1" name="cpGO_6_1" className='add-only' value="1" /> Clear
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_6_2" name="cpGO_6_2" className='add-only' value="1" /> Slurred
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_6_3" name="cpGO_6_3" className='add-only' value="1" /> Rapid
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_6_4" name="cpGO_6_4" className='add-only' value="1" /> Pressured
                        </td>
                         
                    </tr>
                </table>
                <h3>Thought Content</h3>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Delusions</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_7_1" name="cpGO_1_1" className='add-only' value="1" /> No  &nbsp;ne Reported
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_7_2" name="cpGO_7_2" className='add-only' value="1" /> Grandiose
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_7_3" name="cpGO_7_3" className='add-only' value="1" /> Persecutory
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_7_4" name="cpGO_7_4" className='add-only' value="1" /> Somatic
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_7_5" name="cpGO_7_5" className='add-only' value="1" /> Bizarre
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_7_6" name="cpGO_7_6" className='add-only' value="1" /> Nihilistic
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_7_7" name="cpGO_7_7" className='add-only' value="1" /> Religious
                        </td>
                         
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Other</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_8_1" name="cpGO_8_1" className='add-only' value="1" /> No  &nbsp;ne Reported
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_8_2" name="cpGO_8_2" className='add-only' value="1" /> Autistic
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_8_3" name="cpGO_8_3" className='add-only' value="1" /> Obsessional
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_8_4" name="cpGO_8_4" className='add-only' value="1" /> Phobic
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_8_5" name="cpGO_8_5" className='add-only' value="1" /> Guilty
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_8_6" name="cpGO_8_6" className='add-only' value="1" /> Ideas of Reference
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_8_7" name="cpGO_8_7" className='add-only' value="1" /> Preoccupied
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_8_8" name="cpGO_8_8" className='add-only' value="1" /> Guarded
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_8_9" name="cpGO_8_9" className='add-only' value="1" /> Other:
                            <input type='text' id="txtGO_8_10" name="txtGO_8_10" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Self Abuse</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_9_1" name="cpGO_9_1" className='add-only' value="1" /> Suicidal (assess lethality if present):
                        </td>
                        <td className='w-250'>
                            <input type='text' id="txtGO_9_2" name="txtGO_9_2" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_9_3" name="cpGO_9_3" className='add-only' value="1" /> Intent
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_9_4" name="cpGO_9_4" className='add-only' value="1" /> Plan
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_9_5" name="cpGO_9_5" className='add-only' value="1" /> Self Mutilization:
                        </td>
                        <td className='w-250'>
                            <input type='text' id="txtGO_9_6" name="txtGO_9_6" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Aggressive</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_10_1" name="cpGO_10_1" className='add-only' value="1" /> Aggressive (assess lethality if present):
                        </td>
                        <td className='w-250'>
                            <input type='text' id="txtGO_10_2" name="txtGO_10_2" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_10_3" name="cpGO_10_3" className='add-only' value="1" /> Intent
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_10_4" name="cpGO_10_4" className='add-only' value="1" /> Plan
                        </td>
                         
                    </tr>
                </table>
                <h3>Perception</h3>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Hallucinations</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_11_1" name="cpGO_11_1" className='add-only' value="1" /> No  &nbsp;ne Reported
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_11_2" name="cpGO_11_2" className='add-only' value="1" /> Auditory
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_11_3" name="cpGO_11_3" className='add-only' value="1" /> Visual
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_11_4" name="cpGO_11_4" className='add-only' value="1" /> Olfactory
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_11_5" name="cpGO_11_5" className='add-only' value="1" /> Gustatory
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_11_6" name="cpGO_11_6" className='add-only' value="1" /> Tactile
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Other</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_12_1" name="cpGO_12_1" className='add-only' value="1" /> No  &nbsp;ne Reported
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_12_2" name="cpGO_12_2" className='add-only' value="1" /> Illusions
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_12_3" name="cpGO_12_3" className='add-only' value="1" /> Depersonalization
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_12_4" name="cpGO_12_4" className='add-only' value="1" /> Derealization
                        </td>
                         
                    </tr>
                </table>
                <h3>Thought Process</h3>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_13_1" name="cpGO_13_1" className='add-only' value="1" /> Logical
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_13_2" name="cpGO_13_2" className='add-only' value="1" /> Circumstantial
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_13_3" name="cpGO_13_3" className='add-only' value="1" /> Tangential
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_13_4" name="cpGO_13_4" className='add-only' value="1" /> Loose
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_13_5" name="cpGO_13_5" className='add-only' value="1" /> Racing
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_13_6" name="cpGO_13_6" className='add-only' value="1" /> Incoherent
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_13_7" name="cpGO_13_7" className='add-only' value="1" /> Concrete
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_13_8" name="cpGO_13_8" className='add-only' value="1" /> Blocked
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_13_9" name="cpGO_13_9" className='add-only' value="1" /> Flight of Ideas
                        </td>
                    </tr>
                </table>
                <h3>Mood</h3>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_14_1" name="cpGO_14_1" className='add-only' value="1" /> Euthymic
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_14_2" name="cpGO_14_2" className='add-only' value="1" /> Depressed
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_14_3" name="cpGO_14_3" className='add-only' value="1" /> Anxious
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_14_4" name="cpGO_14_4" className='add-only' value="1" /> Angry
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_14_5" name="cpGO_14_5" className='add-only' value="1" /> Euphoric
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_14_6" name="cpGO_14_6" className='add-only' value="1" /> Irritable
                        </td>
                    </tr>
                </table>
                <h3>Affect</h3>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_15_1" name="cpGO_15_1" className='add-only' value="1" /> Full
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_15_2" name="cpGO_15_2" className='add-only' value="1" /> Constricted
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_15_3" name="cpGO_15_3" className='add-only' value="1" /> Flat
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_15_4" name="cpGO_15_4" className='add-only' value="1" /> Inappropriate
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_15_5" name="cpGO_15_5" className='add-only' value="1" /> Labile
                        </td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                </table>
                <h3>Behavior</h3>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_16_1" name="cpGO_16_1" className='add-only' value="1" /> Cooperative
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_16_2" name="cpGO_16_2" className='add-only' value="1" /> Resistant
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_16_3" name="cpGO_16_3" className='add-only' value="1" /> Agitated
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_16_4" name="cpGO_16_4" className='add-only' value="1" /> Impulsive
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_16_5" name="cpGO_16_5" className='add-only' value="1" /> Over Sedated
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_16_6" name="cpGO_16_6" className='add-only' value="1" /> Assaultive
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_16_7" name="cpGO_16_7" className='add-only' value="1" /> Aggressive
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_16_8" name="cpGO_16_8" className='add-only' value="1" /> Hyperactive
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_16_9" name="cpGO_16_9" className='add-only' value="1" /> Restless
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_16_10" name="cpGO_16_10" className='add-only' value="1" /> Loss of Interests
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_16_11" name="cpGO_16_11" className='add-only' value="1" /> Anhedonia
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_16_12" name="cpGO_16_12" className='add-only' value="1" /> Akasthisia
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_16_13" name="cpGO_16_13" className='add-only' value="1" /> Withdrawn
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_16_14" name="cpGO_16_14" className='add-only' value="1" /> Dystonia
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_16_15" name="cpGO_16_15" className='add-only' value="1" /> Tardive Dyskinesia
                        </td>
                    </tr>
                </table>
                <h3>Cognition</h3>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Impairment of</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_17_1" name="cpGO_17_1" className='add-only' value="1" /> No  &nbsp;ne Reported
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_17_2" name="cpGO_17_2" className='add-only' value="1" /> Orientation
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_17_3" name="cpGO_17_3" className='add-only' value="1" /> Memory
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_17_4" name="cpGO_17_4" className='add-only' value="1" /> Attention/Concentration
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_17_5" name="cpGO_17_5" className='add-only' value="1" /> Ability to Abstract
                        </td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Intelligence Estimate</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_18_1" name="cpGO_18_1" className='add-only' value="1" /> MR
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_18_2" name="cpGO_18_2" className='add-only' value="1" /> Borderline
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_18_3" name="cpGO_18_3" className='add-only' value="1" /> Average
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_18_4" name="cpGO_18_4" className='add-only' value="1" /> Above Average
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                </table>
                <h3>Insight/Judgment</h3>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Insight</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_19_1" name="cpGO_19_1" className='add-only' value="1" /> Denies/Minimizes Problem(s)
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_19_2" name="cpGO_19_2" className='add-only' value="1" /> Blames others
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_19_3" name="cpGO_19_3" className='add-only' value="1" /> Poor
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_19_4" name="cpGO_19_4" className='add-only' value="1" /> Fair
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_19_5" name="cpGO_19_5" className='add-only' value="1" /> Good
                        </td> 
                    </tr>
                    <tr> 
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_19_6" name="cpGO_19_6" className='add-only' value="1" /> Other:
                            <input type='text' id="txtGO_19_7" name="txtGO_19_7" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Judgment</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_20_1" name="cpGO_20_1" className='add-only' value="1" /> Age Appropriate
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_20_2" name="cpGO_20_2" className='add-only' value="1" /> Good
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_20_3" name="cpGO_20_3" className='add-only' value="1" /> Fair
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_20_4" name="cpGO_20_4" className='add-only' value="1" /> Poor
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_20_5" name="cpGO_20_5" className='add-only' value="1" /> Seriously Impaired
                        </td> 
                    </tr>
                    <tr> 
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_20_6" name="cpGO_20_6" className='add-only' value="1" /> Other:
                            <input type='text' id="txtGO_20_7" name="txtGO_20_7" className='add-only' />
                        </td>
                    </tr>
                </table>
                <h3>Suicide/Homicide Risk Potential</h3>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Past attempts to Harm Self or Others</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_21_1" name="cpGO_21_1" className='add-only' value="1" /> No  &nbsp;ne Reported
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_21_2" name="cpGO_21_2" className='add-only' value="1" /> Self
                        </td> 
                    </tr>
                    <tr> 
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_21_3" name="cpGO_21_3" className='add-only' value="1" /> Other:
                            <input type='text' id="txtGO_21_4" name="txtGO_21_4" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Comment</span>
                    <textarea id="txtGO_21_5" name="txtGO_21_5" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Current Risk of Harm to Self</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_22_1" name="cpGO_22_1" className='add-only' value="1" /> No  &nbsp;ne Reported
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_22_2" name="cpGO_22_2" className='add-only' value="1" /> Low
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_22_3" name="cpGO_22_3" className='add-only' value="1" /> Moderate
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_22_4" name="cpGO_22_4" className='add-only' value="1" /> High
                        </td>
                         
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Comment</span>
                    <textarea id="txtGO_22_5" name="txtGO_22_5" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Current Risk of Harm to Others</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_23_1" name="cpGO_23_1" className='add-only' value="1" /> No  &nbsp;ne Reported
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_23_2" name="cpGO_23_2" className='add-only' value="1" /> Low
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_23_3" name="cpGO_23_3" className='add-only' value="1" /> Moderate
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_23_4" name="cpGO_23_4" className='add-only' value="1" /> High
                        </td>
                         
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Comment</span>
                    <textarea id="txtGO_23_5" name="txtGO_23_5" className='add-only'></textarea>
                </p>
                <h2>Clinical/Interpretative Summary</h2>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>This Clinical/Interpretative Summary is Based Upon Information Provided By</span>
                            <span className='small'>(check all that apply)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_24_1" name="cpGO_24_1" className='add-only' value="1" /> Client
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_24_2" name="cpGO_24_2" className='add-only' value="1" /> Parent (mother)
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_24_3" name="cpGO_24_3" className='add-only' value="1" /> Guardian(s)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_24_4" name="cpGO_24_4" className='add-only' value="1" /> Family/Friend
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_24_5" name="cpGO_24_5" className='add-only' value="1" /> Physician
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_24_6" name="cpGO_24_6" className='add-only' value="1" /> Records
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_24_7" name="cpGO_24_7" className='add-only' value="1" /> Law Enforcement
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_24_8" name="cpGO_24_8" className='add-only' value="1" /> Service Provider
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cpGO_24_9" name="cpGO_24_9" className='add-only' value="1" /> School Personnel
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cpGO_24_10" name="cpGO_24_10" className='add-only' value="1" /> Others:
                            <input type='text' id="txtGO_24_11" name="txtGO_24_11" className='add-only' />
                        </td>
                    </tr>
                </table>
                <h2>Adult IPRS Target Population Eligibility</h2>
                <span className='small'>(check one box of primary population that applies)</span>
                <table>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cpAIPRS_1" name="cpAIPRS_1" className='add-only' value="1" /> AMI-Adult with Mental Illness
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cpAIPRS_2" name="cpAIPRS_2" className='add-only' value="1" /> AMSRE-AMH Stable Recovery Population
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cpAIPRS_3" name="cpAIPRS_3" className='add-only' value="1" /> AMAO-AMH Assessment Only
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cpAIPRS_4" name="cpAIPRS_4" className='add-only' value="1" /> AMCS-AMH Crisis Services
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cpAIPRS_5" name="cpAIPRS_5" className='add-only' value="1" /> AMCEP-AMH Community Enhancement Program
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cpAIPRS_6" name="cpAIPRS_6" className='add-only' value="1" /> ADSN-Adult with Developmental Disability
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cpAIPRS_7" name="cpAIPRS_7" className='add-only' value="1" /> ADAO-ADD Assessment Only
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cpAIPRS_8" name="cpAIPRS_8" className='add-only' value="1" /> ADCS-ADD Crisis Services
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cpAIPRS_9" name="cpAIPRS_9" className='add-only' value="1" /> ASCDR-ASA Injecting Drug User/Communicable Disease
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cpAIPRS_10" name="cpAIPRS_10" className='add-only' value="1" /> ASDSS-ASA DSS Involved
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cpAIPRS_11" name="cpAIPRS_11" className='add-only' value="1" /> ASTER-ASA Treatment Engagement and Recovery
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cpAIPRS_12" name="cpAIPRS_12" className='add-only' value="1" /> ASWOM-ASA Women
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cpAIPRS_13" name="cpAIPRS_13" className='add-only' value="1" /> ASCJO-ASA Criminal Justice Offender
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cpAIPRS_14" name="cpAIPRS_14" className='add-only' value="1" /> ASAO-ASA Assessment Only
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cpAIPRS_15" name="cpAIPRS_15" className='add-only' value="1" /> ASA Crisis Services
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cpAIPRS_16" name="cpAIPRS_16" className='add-only' value="1" /> CMVET-Veteran and Family (age 18 and over)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cpAIPRS_17" name="cpAIPRS_17" className='add-only' value="1" /> No  &nbsp; IPRS Target Population (Not eligible for IPRS funding)
                        </td>
                        <td className='w-375'>&nbsp;</td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Clinical Impression</span>
                    <span className='small'> (Include consumer's level of readiness and motivation to engage in services) Also include strengths, protective factors, risk of harm, functional status, co-morbidity, and recovery environment/history and treatment needs/goals. </span>
                    <textarea id="txtClinicalImpression" name="txtClinicalImpression" className='add-only'></textarea>
                </p>
                <h2>Diagnosis</h2>
                <table>
                    <tr>
                        <td className='w-100'><span className='eleHeader'>Primary</span></td>
                        <td className='w-100'><span className='eleHeader'>DSM-5 Code</span></td>
                        <td className='w-100'><span className='eleHeader'>ICD-10 Code</span></td>
                        <td className='w-450'><span className='eleHeader'>Narrative Description</span></td>
                    </tr>
                    <tr>
                        <td className='w-100'><input type="checkbox" id="cpDx_1_1" name="cpDx_1_1" className='add-only' value="1" /></td>
                        <td className='w-100'><input type='text' id="txtDx_1_2" name="txtDx_1_2" className='add-only' /></td>
                        <td className='w-100'><input type='text' id="txtDx_1_3" name="txtDx_1_3" className='add-only' /></td>
                        <td className='w-450'><input type='text' id="txtDx_1_4" name="txtDx_1_4" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-100'><input type="checkbox" id="cpDx_2_1" name="cpDx_2_1" className='add-only' value="1" /></td>
                        <td className='w-100'><input type='text' id="txtDx_2_2" name="txtDx_2_2" className='add-only' /></td>
                        <td className='w-100'><input type='text' id="txtDx_2_3" name="txtDx_2_3" className='add-only' /></td>
                        <td className='w-450'><input type='text' id="txtDx_2_4" name="txtDx_2_4" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-100'><input type="checkbox" id="cpDx_3_1" name="cpDx_3_1" className='add-only' value="1" /></td>
                        <td className='w-100'><input type='text' id="txtDx_3_2" name="txtDx_3_2" className='add-only' /></td>
                        <td className='w-100'><input type='text' id="txtDx_3_3" name="txtDx_3_3" className='add-only' /></td>
                        <td className='w-450'><input type='text' id="txtDx_3_4" name="txtDx_3_4" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-100'><input type="checkbox" id="cpDx_4_1" name="cpDx_4_1" className='add-only' value="1" /></td>
                        <td className='w-100'><input type='text' id="txtDx_4_2" name="txtDx_4_2" className='add-only' /></td>
                        <td className='w-100'><input type='text' id="txtDx_4_3" name="txtDx_4_3" className='add-only' /></td>
                        <td className='w-450'><input type='text' id="txtDx_4_4" name="txtDx_4_4" className='add-only' /></td>
                    </tr>
                </table>
                <h4>Add V codes associated</h4>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Problems with primary support group</span></td>
                    </tr>
                    <tr>
                        <td className='w-600'><input type='text' id="txtVCodes_1_1" name="txtVCodes_1_1" className='add-only' /></td>
                        <td className='w-150'>
                            <input type="checkbox" id="cpVCodes_1_2" name="cpVCodes_1" className='add-only' value="1" /> Yes &nbsp;
                            <input type="checkbox" id="cpVCodes_1_3" name="cpVCodes_1" className='add-only' value="2" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Problems related to the social environment</span></td>
                    </tr>
                    <tr>
                        <td className='w-600'><input type='text' id="txtVCodes_2_1" name="txtVCodes_2_1" className='add-only' /></td>
                        <td className='w-150'>
                            <input type="checkbox" id="cpVCodes_2_2" name="cpVCodes_2" className='add-only' value="1" /> Yes &nbsp;
                            <input type="checkbox" id="cpVCodes_2_3" name="cpVCodes_2" className='add-only' value="2" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Educational problems</span></td>
                    </tr>
                    <tr>
                        <td className='w-600'><input type='text' id="txtVCodes_3_1" name="txtVCodes_3_1" className='add-only' /></td>
                        <td className='w-150'>
                            <input type="checkbox" id="cpVCodes_3_2" name="cpVCodes_3" className='add-only' value="1" /> Yes &nbsp;
                            <input type="checkbox" id="cpVCodes_3_3" name="cpVCodes_3" className='add-only' value="2" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Occupational problems</span></td>
                    </tr>
                    <tr>
                        <td className='w-600'><input type='text' id="txtVCodes_4_1" name="txtVCodes_4_1" className='add-only' /></td>
                        <td className='w-150'>
                            <input type="checkbox" id="cpVCodes_4_2" name="cpVCodes_4" className='add-only' value="1" /> Yes &nbsp;
                            <input type="checkbox" id="cpVCodes_4_3" name="cpVCodes_4" className='add-only' value="2" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Housing problems</span></td>
                    </tr>
                    <tr>
                        <td className='w-600'><input type='text' id="txtVCodes_5_1" name="txtVCodes_5_1" className='add-only' /></td>
                        <td className='w-150'>
                            <input type="checkbox" id="cpVCodes_5_2" name="cpVCodes_5" className='add-only' value="1" /> Yes &nbsp;
                            <input type="checkbox" id="cpVCodes_5_3" name="cpVCodes_5" className='add-only' value="2" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Economic problems</span></td>
                    </tr>
                    <tr>
                        <td className='w-600'><input type='text' id="txtVCodes_6_1" name="txtVCodes_6_1" className='add-only' /></td>
                        <td className='w-150'>
                            <input type="checkbox" id="cpVCodes_6_2" name="cpVCodes_6" className='add-only' value="1" /> Yes &nbsp;
                            <input type="checkbox" id="cpVCodes_6_3" name="cpVCodes_6" className='add-only' value="2" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Problems with access to health care services</span></td>
                    </tr>
                    <tr>
                        <td className='w-600'><input type='text' id="txtVCodes_7_1" name="txtVCodes_7_1" className='add-only' /></td>
                        <td className='w-150'>
                            <input type="checkbox" id="cpVCodes_7_2" name="cpVCodes_7" className='add-only' value="1" /> Yes &nbsp;
                            <input type="checkbox" id="cpVCodes_7_3" name="cpVCodes_7" className='add-only' value="2" /> No
                        </td>
                    </tr>
                </table>
                <h2>Treatment Recommendations/Needs to be addressed in Person Centered Plan</h2>
                <table>
                    <tr>
                        <td className='w-375'><input type="checkbox" id="cpPCP_1" name="cpPCP_1" className='add-only' value="1" /> MH Individual Therapy</td>
                        <td className='w-375'><input type="checkbox" id="cpPCP_2" name="cpPCP_2" className='add-only' value="1" /> Medication Monitoring</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type="checkbox" id="cpPCP_3" name="cpPCP_3" className='add-only' value="1" /> Mobile Crisis Management Services</td>
                        <td className='w-375'><input type="checkbox" id="cpPCP_4" name="cpPCP_4" className='add-only' value="1" /> MH Group Therapy</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type="checkbox" id="cpPCP_5" name="cpPCP_5" className='add-only' value="1" /> Psychiatric Evaluation</td>
                        <td className='w-375'><input type="checkbox" id="cpPCP_6" name="cpPCP_6" className='add-only' value="1" /> Shelter</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type="checkbox" id="cpPCP_7" name="cpPCP_7" className='add-only' value="1" /> MH Family Therapy</td>
                        <td className='w-375'><input type="checkbox" id="cpPCP_8" name="cpPCP_8" className='add-only' value="1" /> Psychological Evaluation</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type="checkbox" id="cpPCP_9" name="cpPCP_9" className='add-only' value="1" /> Housing</td>
                        <td className='w-375'><input type="checkbox" id="cpPCP_10" name="cpPCP_10" className='add-only' value="1" /> Intensive In-home Service</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type="checkbox" id="cpPCP_11" name="cpPCP_11" className='add-only' value="1" /> Residential Treatment (Level III/IV)</td>
                        <td className='w-375'><input type="checkbox" id="cpPCP_12" name="cpPCP_12" className='add-only' value="1" /> Medical/Neurological Eval.</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type="checkbox" id="cpPCP_13" name="cpPCP_13" className='add-only' value="1" /> Community Support Team</td>
                        <td className='w-375'><input type="checkbox" id="cpPCP_14" name="cpPCP_14" className='add-only' value="1" /> Respite</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type="checkbox" id="cpPCP_15" name="cpPCP_15" className='add-only' value="1" /> Vocational Rehabilitation</td>
                        <td className='w-375'><input type="checkbox" id="cpPCP_16" name="cpPCP_16" className='add-only' value="1" /> Psychosocial Rehabilitation</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type="checkbox" id="cpPCP_17" name="cpPCP_17" className='add-only' value="1" /> Veteran Affairs</td>
                        <td className='w-375'><input type="checkbox" id="cpPCP_18" name="cpPCP_18" className='add-only' value="1" /> Faith Based Referral</td>

                    </tr>
                    <tr>
                        <td className='w-375'><input type="checkbox" id="cpPCP_19" name="cpPCP_19" className='add-only' value="1" /> SA Outpatient Services</td>
                        <td className='w-375'><input type="checkbox" id="cpPCP_20" name="cpPCP_20" className='add-only' value="1" /> Department of Social Services</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type="checkbox" id="cpPCP_21" name="cpPCP_21" className='add-only' value="1" /> Food Bank </td>
                        <td className='w-375'><input type="checkbox" id="cpPCP_22" name="cpPCP_22" className='add-only' value="1" /> SA Intensive Outpatient Services (SAIOP)</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type="checkbox" id="cpPCP_23" name="cpPCP_23" className='add-only' value="1" /> Legal Services </td>
                        <td className='w-375'><input type="checkbox" id="cpPCP_24" name="cpPCP_24" className='add-only' value="1" /> ACTT</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type="checkbox" id="cpPCP_25" name="cpPCP_25" className='add-only' value="1" /> SA Partial Hospitalization Services (SACOT)</td>
                        <td className='w-375'><input type="checkbox" id="cpPCP_26" name="cpPCP_26" className='add-only' value="1" /> IDDT</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type="checkbox" id="cpPCP_27" name="cpPCP_27" className='add-only' value="1" /> Family Psycho-Ed</td>
                        <td className='w-375'><input type="checkbox" id="cpPCP_28" name="cpPCP_28" className='add-only' value="1" /> SA Low-Intensity Residential Services</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type="checkbox" id="cpPCP_29" name="cpPCP_29" className='add-only' value="1" /> AA/NA</td>
                        <td className='w-375'><input type="checkbox" id="cpPCP_30" name="cpPCP_30" className='add-only' value="1" /> Wellness/Illness Management Recovery</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type="checkbox" id="cpPCP_31" name="cpPCP_31" className='add-only' value="1" /> SA Clinically Managed Population-Specific, High-Intensity Residential Services</td>
                        <td className='w-375'><input type="checkbox" id="cpPCP_34" name="cpPCP_34" className='add-only' value="1" /> SA Medically Monitored Intensive Inpatient Services (Adult Criteria)</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type="checkbox" id="cpPCP_32" name="cpPCP_32" className='add-only' value="1" /> Interpreter Services</td>
                        <td className='w-375'><input type="checkbox" id="cpPCP_33" name="cpPCP_33" className='add-only' value="1" /> Social Security Administration</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type="checkbox" id="cpPCP_35" name="cpPCP_35" className='add-only' value="1" /> Nutritional</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cpPCP_36" name="cpPCP_36" className='add-only' value="1" /> Other:
                            <input type='text' id="txtPCP_37" name="txtPCP_37" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type="checkbox" id="cpPCP_38" name="cpPCP_38" className='add-only' value="1" /> SA Medically Monitored/Managed Intensive Inpatient Services</td>
                        <td className='w-375'><input type="checkbox" id="cpPCP_39" name="cpPCP_39" className='add-only' value="1" /> Auditory/Visual Assessment</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cpPCP_40" name="cpPCP_40" className='add-only' value="1" /> Other:
                            <input type='text' id="txtPCP_41" name="txtPCP_41" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type="checkbox" id="cpPCP_42" name="cpPCP_42" className='add-only' value="1" /> SA Medically Managed Intensive Inpatient Services</td>
                        <td className='w-375'><input type="checkbox" id="cpPCP_43" name="cpPCP_43" className='add-only' value="1" /> SA Clinically Manage High-Intensity Residential Services (Adult Criteria)</td>
                        <td className='w-375'>&nbsp;</td>
                    </tr>
                </table>

                <h2>SAIOP & SACOT</h2>
                <h2>{` ASAM Dimension 1.) Acute Intoxication and Withdrawal `}</h2>
                <p>
                    <span className='eleHeader'>Is there significant risk of severe withdrawal symptoms or seizures, based on the patient's previous withdrawal history, amount, frequency, chronicity and recency of discontinuation or significant reduction of alcohol or other drug use?</span>
                    <span className='small'>Explain:</span>
                    <textarea id="txtExplain_1" name="txtExplain_1" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Are there current signs of withdrawal?</span>
                    <input type="radio" id="rbWithDrawal_Yes" name="rbWithDrawal" className='add-only' value="Yes" /> Yes &nbsp;
                    <input type="radio" id="rbWithDrawal_No" name="rbWithDrawal" className='add-only' value="No" /> No
                    <span className='small'>Explain:</span>
                    <textarea id="txtExplain_2" name="txtExplain_2" className='add-only'></textarea>
                </p>
                <p>
                    <input type="checkbox" id="cbSaiop_1" name="cbSaiop_1" className='add-only' value="1" />
                    No withdrawal needs or can be managed at level 2.1 (SAIOP)<br />
                    <input type="checkbox" id="cbSacot_1" name="cbSacot_1" className='add-only' value="1" />
                    Moderate Risk of Severe Withdrawal without assistance/program level 2.5 (SACOT)
                </p>

                <h2>{` ASAM Dimension 2.) Bio-Medical Conditions and Complications`}</h2>
                <p>
                    <span className='eleHeader'>Are there current physical/medical illnesses, other than withdrawal symptoms?</span>
                    <span className='small'>Explain:</span>
                    <textarea id="txtExplain_3" name="txtExplain_3" className='add-only'></textarea>
                </p>
                <p>
                    <input type="checkbox" id="cbSaiop_2" name="cbSaiop_2" className='add-only' value="1" />
                    If present the conditions are stable and won't interfere with treatment (SAIOP) <br />
                    <input type="checkbox" id="cbSacot_2" name="cbSacot_2" className='add-only' value="1" />
                    If present the conditions won't interfere with treatment but would distract from recovery without level 2.5 management (SACOT)
                </p>
                <h2>{` ASAM Dimension 3.) Cognitive, Behavioral, and Emotional Conditions`}</h2>
                <p>
                    <span className='eleHeader'>Are there current psychiatric illnesses or psychological, behavioral, emotional or cognitive problems that need to be addressed because they create risk or complicate treatment?</span>
                    <span className='small'>Explain:</span>
                    <textarea id="txtExplain_4" name="txtExplain_4" className='add-only'></textarea>
                </p>
                <p>
                    <input type="checkbox" id="cbSaiop_3" name="cbSaiop_3" className='add-only' value="1" />
                    If present is mild in severity and only needs outpatient monitoring, to minimize distractions from recovery in SAIOP clients.  <br />
                    <input type="checkbox" id="cbSacot_3" name="cbSacot_3" className='add-only' value="1" />
                    If present in SACOT clients need to recommend dual diagnosis treatment (which includes MH therapy with/without medication treatment)
                </p>
                <h2>{` ASAM Dimension 4.) Readiness to Change / Motivation`}</h2>
                <p>
                    <span className='eleHeader'>What is the individual's emotional and cognitive awareness of the need to change, his or her level of commitment to and readiness for change, or has been his or her degree of cooperation with treatment, awareness of negative consequences of substance abuse?</span>
                    <span className='small'>Explain:</span>
                    <textarea id="txtExplain_5" name="txtExplain_5" className='add-only'></textarea>
                </p>
                <p>
                    <input type="checkbox" id="cbSaiop_4" name="cbSaiop_4" className='add-only' value="1" />
                    Resistance to change is high enough requiring a structured program (SAIOP) <br />
                    <input type="checkbox" id="cbSacot_4" name="cbSacot_4" className='add-only' value="1" />
                    Resistance to change high and there is evidence of failure of interventions at lesser levels or poor impulse control and follow through with less intense programs (SACOT)
                </p>
                <p>
                    <span className='eleHeader'>Explain lower level treatment received by the client or why lower level of treatment won't be equally effective</span>
                    <textarea id="txtExplain_6" name="txtExplain_6" className='add-only'></textarea>
                </p>
                <h2>{` ASAM Dimension 5.) Relapse, Continued Use, Continued Problem`}</h2>
                <p>
                    <span className='eleHeader'>Is the patient at risk of continued drug or alcohol use, does the patient have any recognition of, understanding of, or skills with which to cope with his or her addictive or mental disorder in order to prevent relapse, continued use?</span>
                    <textarea id="txtContinuedUse" name="txtContinuedUse" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>How severe are the problems and further distress that may continue or reappear if the patient is not successfully engaged in treatment at this time?</span>
                    <textarea id="txtHowSevere" name="txtHowSevere" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>How aware is the patient of relapse triggers, ways to cope with cravings to use, and skills to control impulses to use or impulses to harm self or others?</span>
                    <textarea id="txtHowAware" name="txtHowAware" className='add-only'></textarea>
                </p>
                <p>
                    <input type="checkbox" id="cbSaiop_5" name="cbSaiop_5" className='add-only' value="1" />
                    Intensification of symptoms despite participation in outpatient therapy, and there is high likely hood of relapse without close monitoring and support (SAIOP)  <br />
                    <input type="checkbox" id="cbSacot_5" name="cbSacot_5" className='add-only' value="1" />
                    Despite active involvement in lower level treatment plans, continues to experience deterioration in functioning/symptoms (SACOT)
                </p>

                <h2>{` ASAM Dimension 6.) Recovery Environment`}</h2>
                <p>
                    <span className='eleHeader'>Do any family members, significant others, living situations or school or work situations pose a threat to the patients safety or engagement in treatment, does the patient have supportive friendships, financial resources, or educational/ vocational resources that can increase the likelihood of successful treatment?</span>
                    <span className='small'>Explain:</span>
                    <textarea id="txtExplain_7" name="txtExplain_7" className='add-only'></textarea>
                </p>
                <p>
                    <input type="checkbox" id="cbSaiop_6" name="cbSaiop_6" className='add-only' value="1" />
                    Lack of social contacts or social contacts aren't helpful to recovery, but with structure or support the patient can cope (SAIOP) <br />
                    <input type="checkbox" id="cbSacot_6" name="cbSacot_6" className='add-only' value="1" />
                    Environment is unsupportive but with structure or support and relief from home environment the patient can cope (SACOT)
                </p>

                <h2>Premier Behavioral Services - Entrance Criteria - Community Support</h2>
                <span className='small'>(Please Explain in space provided)</span>
                <p>This is documented, significant impairment in at least two of the life domains (emotional, social, safety, housing, medical/health, educational, vocational, and legal). This impairment is related to the recipient's diagnosis and impedes his or her use of the skills necessary for independent functioning in the community.</p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Emotional</span>
                            <input type="checkbox" id="cpPBS_1_1" name="cpPBS_1" className='add-only' value="1" /> Yes &nbsp;
                            <input type="checkbox" id="cpPBS_1_2" name="cpPBS_1" className='add-only' value="2" /> No
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Safety</span>
                            <input type="checkbox" id="cpPBS_2_1" name="cpPBS_2" className='add-only' value="1" /> Yes &nbsp;
                            <input type="checkbox" id="cpPBS_2_2" name="cpPBS_2" className='add-only' value="2" /> No
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Housing</span>
                            <input type="checkbox" id="cpPBS_3_1" name="cpPBS_3" className='add-only' value="1" /> Yes &nbsp;
                            <input type="checkbox" id="cpPBS_3_2" name="cpPBS_3" className='add-only' value="2" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Medical/Health</span>
                            <input type="checkbox" id="cpPBS_4_1" name="cpPBS_4" className='add-only' value="1" /> Yes &nbsp;
                            <input type="checkbox" id="cpPBS_4_2" name="cpPBS_4" className='add-only' value="2" /> No
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Educational</span>
                            <input type="checkbox" id="cpPBS_5_1" name="cpPBS_5" className='add-only' value="1" /> Yes &nbsp;
                            <input type="checkbox" id="cpPBS_5_2" name="cpPBS_5" className='add-only' value="2" /> No
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Vocational</span>
                            <input type="checkbox" id="cpPBS_6_1" name="cpPBS_6" className='add-only' value="1" /> Yes &nbsp;
                            <input type="checkbox" id="cpPBS_6_2" name="cpPBS_6" className='add-only' value="2" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Legal</span>
                            <input type="checkbox" id="cpPBS_7_1" name="cpPBS_7" className='add-only' value="1" /> Yes &nbsp;
                            <input type="checkbox" id="cpPBS_7_2" name="cpPBS_7" className='add-only' value="2" /> No
                        </td> 
                    </tr>
                </table>
                <h4>AND</h4>
                <p>
                    <span className='eleHeader'>A) There is an Axis I or II MH/SA diagnosis (as defined by the DSM-IV-TR or it successors), other than a sole diagnosis of developmental disability.</span>
                    <input type="checkbox" id="cpA_1" name="cpA" className='add-only' value="1" /> Met
                    <input type="checkbox" id="cpA_2" name="cpA" className='add-only' value="2" /> Not Met
                </p>
                <p>
                    <span className='eleHeader'>Explain</span>
                    <textarea id="txtAExplain" name="txtAExplain" className='add-only'></textarea>
                </p>
                <h4>AND</h4>
                <p>
                    <span className='eleHeader'>B) For recipients with a primary substance-related diagnosis, the American Society for Addiction Medicine Patient Place Criteria are met.</span>
                    <input type="checkbox" id="cpB_1" name="cpB" className='add-only' value="1" /> Yes &nbsp;
                    <input type="checkbox" id="cpB_2" name="cpB" className='add-only' value="2" /> No
                </p>
                <p>
                    <span className='eleHeader'>Explain</span>
                    <textarea id="txtBExplain" name="txtBExplain" className='add-only'></textarea>
                </p>
                <h4>AND</h4>
                <h4>Four or more of the following conditions related to the diagnosis are present</h4>
                <p>
                    <span className='eleHeader'>1) High use of acute psychiatric hospital or crisis/emergency services (2 or more admission in a year), extended hospital stay (30 day within the past year) or psychiatric emergency services.</span>
                    <input type="checkbox" id="cpC1_1" name="cpC1" className='add-only' value="1" /> Yes &nbsp;
                    <input type="checkbox" id="cpC1_2" name="cpC1" className='add-only' value="2" /> No
                </p>
                <p>
                    <span className='eleHeader'>Explain</span>
                    <textarea id="txtC1Explain" name="txtC1Explain" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>2) History of difficulty using traditional service (missing office appointment, difficulty maintaining medication schedule, etc.)</span>
                    <input type="checkbox" id="cpC2_1" name="cpC2" className='add-only' value="1" /> Yes &nbsp;
                    <input type="checkbox" id="cpC2_2" name="cpC2" className='add-only' value="2" /> No
                </p>
                <p>
                    <span className='eleHeader'>Explain</span>
                    <textarea id="txtC2Explain" name="txtC2Explain" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>3) Intermittently medication refractory (not achieving full response to medication or sustained reduction of symptoms) or difficulty maintaining compliance with taking medication.</span>
                    <input type="checkbox" id="cpC3_1" name="cpC3" className='add-only' value="1" /> Yes &nbsp;
                    <input type="checkbox" id="cpC3_2" name="cpC3" className='add-only' value="2" /> No
                </p>
                <p>
                    <span className='eleHeader'>Explain</span>
                    <textarea id="txtC3Explain" name="txtC3Explain" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>4) Co-occurring diagnosis of substance abuse (ASAM - any level of care) and mental illness.</span>
                    <input type="checkbox" id="cpC4_1" name="cpC4" className='add-only' value="1" /> Yes &nbsp;
                    <input type="checkbox" id="cpC4_2" name="cpC4" className='add-only' value="2" /> No
                </p>
                <p>
                    <span className='eleHeader'>Explain</span>
                    <textarea id="txtC4Explain" name="txtC4Explain" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>5) Legal issues (conditional release for non-violent offense; history of failure to show in court, etc.) related to Axis I or Axis II MH/SA diagnosis.</span>
                    <input type="checkbox" id="cpC5_1" name="cpC5" className='add-only' value="1" /> Yes &nbsp;
                    <input type="checkbox" id="cpC5_2" name="cpC5" className='add-only' value="2" /> No
                </p>
                <p>
                    <span className='eleHeader'>Explain</span>
                    <textarea id="txtC5Explain" name="txtC5Explain" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>6) Homeless or at high risk of homelessness due to residential instability resulting from Axis I or Axis II MH/SA diagnosis.</span>
                    <input type="checkbox" id="cpC6_1" name="cpC6" className='add-only' value="1" /> Yes &nbsp;
                    <input type="checkbox" id="cpC6_2" name="cpC6" className='add-only' value="2" /> No
                </p>
                <p>
                    <span className='eleHeader'>Explain</span>
                    <textarea id="txtC6Explain" name="txtC6Explain" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>7) Suicidal gestures, persistent ideation, in past 3 months.</span>
                    <input type="checkbox" id="cpC7_1" name="cpC7" className='add-only' value="1" /> Yes &nbsp;
                    <input type="checkbox" id="cpC7_2" name="cpC7" className='add-only' value="2" /> No
                </p>
                <p>
                    <span className='eleHeader'>Explain</span>
                    <textarea id="txtC7Explain" name="txtC7Explain" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>8) Inappropriate public behavior within the past 3 months.</span>
                    <input type="checkbox" id="cpC8_1" name="cpC8" className='add-only' value="1" /> Yes &nbsp;
                    <input type="checkbox" id="cpC8_2" name="cpC8" className='add-only' value="2" /> No
                </p>
                <p>
                    <span className='eleHeader'>Explain</span>
                    <textarea id="txtC8Explain" name="txtC8Explain" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>9) Within the past 6 months, physical aggression, intense verbal aggression, toward self or others (due to symptoms associated with diagnosis) sufficient to create functional problems in the home, community, school, job, etc.</span>
                    <input type="checkbox" id="cpC9_1" name="cpC9" className='add-only' value="1" /> Yes &nbsp;
                    <input type="checkbox" id="cpC9_2" name="cpC9" className='add-only' value="2" /> No
                </p>
                <p>
                    <span className='eleHeader'>Explain</span>
                    <textarea id="txtC9Explain" name="txtC9Explain" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>10) A less intense level of care has been tried and found to ineffective for the clinical needs of the recipient.</span>
                    <input type="checkbox" id="cpC10_1" name="cpC10" className='add-only' value="1" /> Yes &nbsp;
                    <input type="checkbox" id="cpC10_2" name="cpC10" className='add-only' value="2" /> No
                </p>
                <p>
                    <span className='eleHeader'>Explain</span>
                    <textarea id="txtC10Explain" name="txtC10Explain" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Total Score</span>
                            <span className='small'>(total should be 4 or more)</span>
                            <input type='text' id="txtTotalScore" name="txtTotalScore" className='add-only' />
                        </td>
                    </tr>
                </table>
                <h4>AND</h4>
                <p>
                    <span className='eleHeader'>D) There is no evidence to support that alternative interventions would be equally or more effective based on North Carolina community practice Standards (for example, ASAM, APA) as available.</span>
                    <input type="checkbox" id="cpD_1" name="cpD" className='add-only' value="1" /> Met
                    <input type="checkbox" id="cpD_2" name="cpD" className='add-only' value="2" /> Not Met
                </p>
                <p>
                    <span className='eleHeader'>Explain</span>
                    <textarea id="txtDExplain" name="txtDExplain" className='add-only'></textarea>
                </p>
                <h2>Premier Behavioral Services - Entrance Criteria - Psychosocial Rehabilitation</h2>
                <p>
                    <span className='eleHeader'>A) Axis I or Axis II diagnosis present.</span>
                    <input type="checkbox" id="cpA1_1" name="cpA" className='add-only' value="1" /> Yes &nbsp;
                    <input type="checkbox" id="cpA1_2" name="cpA" className='add-only' value="2" /> No
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Axis I</span>
                            <input type='text' id="txtAxisI" name="txtAxisI" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Axis II</span>
                            <input type='text' id="txtAxisII" name="txtAxisII" className='add-only' />
                        </td>
                    </tr>
                </table>
                <h4>AND</h4>
                <p>
                    <span className='eleHeader'>B) Level of Care Criteria</span>
                </p>
                <h4>AND</h4>
                <p>
                    <span className='eleHeader'>C) Impaired role functioning that adversely affects at Least 2 of the following:</span>
                </p>
                <table>
                    <tr>
                        <td className='w-550'>
                            1) Employment
                        </td>
                        <td className='w-200'>
                            <input type="checkbox" id="cpB1_1" name="cpB1" className='add-only' value="1" /> Yes &nbsp;
                            <input type="checkbox" id="cpB1_2" name="cpB1" className='add-only' value="2" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-550'>
                            2) Management of finances
                        </td>
                        <td className='w-200'>
                            <input type="checkbox" id="cpB2_3" name="cpB1" className='add-only' value="3" /> Yes &nbsp;
                            <input type="checkbox" id="cpB2_4" name="cpB1" className='add-only' value="4" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-550'>
                            3) Ability to procure public support services
                        </td>
                        <td className='w-200'>
                            <input type="checkbox" id="cpB3_5" name="cpB1" className='add-only' value="5" /> Yes &nbsp;
                            <input type="checkbox" id="cpB3_6" name="cpB1" className='add-only' value="6" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-550'>
                            4) Appropriateness of Social Behavior
                        </td>
                        <td className='w-200'>
                            <input type="checkbox" id="cpB4_7" name="cpB1" className='add-only' value="7" /> Yes &nbsp;
                            <input type="checkbox" id="cpB4_8" name="cpB1" className='add-only' value="8" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-550'>
                            5) Activities of daily living
                        </td>
                        <td className='w-200'>
                            <input type="checkbox" id="cpB5_9" name="cpB1" className='add-only' value="9" /> Yes &nbsp;
                            <input type="checkbox" id="cpB5_10" name="cpB1" className='add-only' value="10" /> No
                        </td>
                    </tr>
                </table>
                <h4>AND</h4>
                <p>
                    <span className='eleHeader'>The recipient's level of functioning may indicate a need for PSR if the recipient has unmet needs related to recovery and regaining the skills and experience needed to maintain personal care, meal preparation, housing or to access social, vocational and recreational opportunities in the community.</span>
                    <input type="checkbox" id="cpX_1" name="cpX" className='add-only' value="1" /> Yes &nbsp;
                    <input type="checkbox" id="cpX_2" name="cpX" className='add-only' value="2" /> No
                </p>
                <p>
                    <span className='eleHeader'>Explain</span>
                    <textarea id="txtXExplain" name="txtXExplain" className='add-only'></textarea>
                </p>
                <h2>Assessment Interdisciplinary Team Progress Note</h2>
                <p>The team discussed the consumer's Assessment, Diagnosis and Treatment Plan.</p>
                <p>
                    <span className='eleHeader'>Any changes in assessment</span>
                    <input type="checkbox" id="cpY_1" name="cpY" className='add-only' value="1" /> Yes &nbsp;
                    <input type="checkbox" id="cpY_2" name="cpY" className='add-only' value="2" /> No
                </p>
                <p>
                    <span className='eleHeader'>If yes, please explain</span>
                    <textarea id="txtYExplain" name="txtYExplain" className='add-only'></textarea>
                </p>

                <p>
                    <input type="checkbox" id="cbIndividualEducatedVerballyAcknowledged" name="cbIndividualEducatedVerballyAcknowledged" className='add-only' value="IndividualEducatedVerballyAcknowledged" />
                    Individual was educated on and verbally acknowledged the risks and benefits of the medications listed within this note via telehealth.
                </p>
                <table>
                    <tr>
                        <td className='signature w-600'>&nbsp;</td>
                        <td className='signature w-150'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-600'>Signature Qualified Professional</td>
                        <td className='small w-150'>Date</td>
                    </tr>
                    <tr>
                        <td className='signature w-600'>&nbsp;</td>
                        <td className='signature w-150'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-600'>Signature of License Professional</td>
                        <td className='small w-375'>Date</td>
                    </tr>
                    <tr>
                        <td className='signature w-600'>&nbsp;</td>
                        <td className='signature w-150'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-600'>Signature of License Professional</td>
                        <td className='small w-150'>Date</td>
                    </tr>
                    <tr>
                        <td className='signature w-600'>&nbsp;</td>
                        <td className='signature w-150'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-600'>MD License Professional</td>
                        <td className='small w-150'>Date</td>
                    </tr>
                </table>
                <h2>Signatures</h2>
                <p>I acknowledge that all documentation contained in this clinical assessment was information provided by the above listed client on this date.</p>
                <table>
                    <tr>
                        <td className='signature w-600'>&nbsp;</td>
                        <td className='signature w-150'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-600'>Licensed Professional Signature/Credentials</td>
                        <td className='small w-150'>Date</td>
                    </tr>
                    <tr>
                        <td className='signature w-600'>&nbsp;</td>
                        <td className='signature w-150'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-600'>Clinical Director Signature/Credentials</td>
                        <td className='small w-150'>Date</td>
                    </tr>
                    <tr>
                        <td className='signature w-600'>&nbsp;</td>
                        <td className='signature w-150'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-600'>QM Director Signature/Credentials</td>
                        <td className='small w-150'>Date</td>
                    </tr>
                    <tr>
                        <td className='signature w-600'>&nbsp;</td>
                        <td className='signature w-150'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-600'>Medical Director Signature/Credentials</td>
                        <td className='small w-150'>Date</td>
                    </tr>
                    <tr>
                        <td className='signature w-600'>&nbsp;</td>
                        <td className='signature w-150'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-600'>MD/DO Signature/Credentials</td>
                        <td className='small w-150'>Date</td>
                    </tr>
                    <tr>
                        <td className='signature w-600'>&nbsp;</td>
                        <td className='signature w-150'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-600'>Qualified Professional Signature/Credentials</td>
                        <td className='small w-150'>Date</td>
                    </tr>
                </table>


            </div>
        </form>

    )
}  
